import { normalizeLanguage } from '../../utils/languagePreference';
/* eslint-disable max-len */
import { initialSRBExpiry, currentSRBExpiry, srbExpirySubmission, validateSRBExpiry } from '../../utils/srbChartExpiry';
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import { push, replace } from 'react-router-redux';
import { withTranslation, Trans } from 'react-i18next';
import _ from 'lodash';
import clone from 'clone';
import {
  Button,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Label,
  List,
  Menu,
  Segment,
  Message,
  Dimmer,
  Loader,
  Icon,
  Popup,
} from 'semantic-ui-react';
import 'react-day-picker/lib/style.css';
import moment from 'moment-timezone';
import qs from 'qs';
import { required, numericRange, stringLength, email } from '@mhub/web-validations';
import { RX_EMAIL } from '@mhub/web-validations/dist/constants/index';
import Currencies from '../../components/Currencies';
import BookingFormTemplateList from '../../components/BookingFormTemplateList';
import BankAccounts from '../../components/BankAccounts';
import config from '../../../config';
import { validateForm } from '../../utils/validations';
import { fetchM, serverRequestPost, serverRequestPut, serverRequestDelete } from '../../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage, flashMessage } from '../../actions/flash';
import { promptChangesMessage } from '../../actions/prompt';
// import { fetchBobForms } from '../../actions/bobForms';
import { fetchTemplates } from '../../actions/templates';
import { fetchSalesChartTypes } from '../../actions/salesChartTypes';
import { PAYMS_PAYMENT_GATEWAY_BILLPLZ, PAYMS_PAYMENT_GATEWAY_IPAY88 } from '../../constants/payments';
import { SELECT_COUNTRIES, isCountryVietnam } from '../../constants/countries';
import INTL_CALL_CODES from '../../constants/intlCallCodes';
import PROJECT_STATUSES from '../../constants/projectStatuses';
import STATES from '../../constants/states';
import {
  UPLOAD_PICTURE_PROMPT,
} from '../../constants/promptMessages';
import AppForm from '../../components/AppForm';
import Select from '../../components/AppForm/Select';
import SpecificationTable from '../../components/SpecificationTable';
import SearchBranch from '../../components/SearchBranch';
import PhoneInput from '../../components/AppForm/PhoneInput';
import MarkdownText from '../../components/MarkdownText';
import UploadModal from '../../components/UploadModal';
import SortButton from '../../components/SortButton';
import ProjectPricingTier from '../../components/ProjectPricingTier';
import CustomField from '../../components/CustomField';
import { sanitizeUrl, siteplanUrl } from '../../utils/url';
import phone from '../../utils/validations/phone';
import TextFieldMarkdownPreview from '../../components/TextFieldMarkdownPreview';
import DropdownInputNumber from '../../components/DropdownInputNumber';
import ProjectHimsSettingsForm from '../../components/ProjectHimsSettingsForm';

import UploadSiteplanForm from './Siteplan/SiteplanForm';
import UploadSvgForm from './Siteplan/SvgForm';
import UploadImageForm from './Siteplan/ImageForm';
import UnpublishProjectModal from '../Project/UnpublishProjectModal';
import MarketplaceTncModal from './MarketplaceTncModal';
import { PROPERTY_CATEGORY_HIGH_RISE } from '../../constants/propertyCategories';
import { BUYER_MARKETPLACE } from '../../constants/apps';

import DateTimePicker from '../../components/DateTimePicker';
import Countdown from '../../components/CountdownAdvance';
import { isForeignCompany } from '../../utils/companies';
import INTL_FLAG_CODES from '../../constants/intlFlagCodes';
import PAYMENT_TYPES from '../../constants/paymentTypes';
import BOOKING_STATUSES from '../../constants/bookingStatuses';
import BOOKING_STATUSES_TIN_VALIDATION from '../../constants/tin';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { HIMS_SPA_LAWYER_REP_OPTIONS, HIMS_STRATA_OPTIONS } from '../../constants/hims';
import { getConstantsLabel, translateModels } from '../../utils/translation';
import { getDefaultProjectSourceOfFinanceOptions, getSourceOfFinanceValue } from '../../utils/financeSource';
import {
  FOREIGN_PURCHASE_THRESHOLD_DEFAULT,
  showsForeignPurchaseThreshold,
  validateForeignPurchaseThreshold,
  foreignPurchaseThresholdOrDefault,
  foreignPurchaseThresholdSubmission,
} from '../../utils/foreignPurchaseThreshold';
import { changeUnitAccessesOptions, CU_EXTERNAL_STAFF_ACCESS } from '../../constants/changeUnitsAccesses';
import {
  defaultBookingNoteAccesses,
  bookingNoteAccessesOptions,
  SR_ROLE_ID_DEVELOPER_HEADQUARTERS,
  defaultRduAccesses,
  rduAccessesOptions,
  defaultPaymentReceiptAccesses,
  paymentReceiptAccessesOptions,
  preSalesLaunchRoleOptions,
} from '../../constants/srRoleAccess';
import { bookingNoteDefaultPrivacyOptions } from '../../constants/bookingNote';
import { canManagePreSalesLaunch } from '../../utils/preSalesLaunch';
import { vnHidesChangeUnitOptions } from '../../utils/vietnam';
import DocxTemplaterForm from '../../components/DocxTemplaterForm';
import MergeTagDictTabList from '../../components/MergeTagDictTabList';
import DocxTemplateGuides from '../../components/DocxTemplateGuides';

const isPRS = config.get('prs');
const inputDateFormat = 'DD/MM/YYYY, hh:mm A';

class ProjectForm extends Component {
  static propTypes = {
    onClose: PropTypes.bool,
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        creditControlIsEnabled: PropTypes.bool,
        onlinePaymentEnabled: PropTypes.bool,
        paymsPaymentGateway: PropTypes.string,
        himsIsEnabled: PropTypes.bool,
        settings: PropTypes.shape({
          virtualAccountIsEnabled: PropTypes.bool,
          generateQuotationIsEnabled: PropTypes.bool,
        }),
      }),
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isAdminCommunity: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isDeveloperSupervisor: PropTypes.bool,
      isDeveloperSalesManager: PropTypes.bool,
      isDeveloperSalesAdmin: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      company: PropTypes.shape({
        companyCurrency: PropTypes.oneOfType([
          PropTypes.array,
        ]),
        countryCode: PropTypes.string,
        service_company_id: PropTypes.string,
      }),
      companyApps: PropTypes.arrayOf(PropTypes.shape({
        appID: PropTypes.string,
      })),
    }),
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    project: PropTypes.shape({
      name: PropTypes.string,
      marketplaceIsPublish: PropTypes.bool,
      marketplaceBuyerIsPublish: PropTypes.bool,
      isProjectBAC: PropTypes.bool,
      mpAllowESignFormAtReserve: PropTypes.bool,
      statusID: PropTypes.string,
      projectFormAccessibilities: PropTypes.array,
    }),
    location: PropTypes.shape({
      hash: PropTypes.string,
      pathname: PropTypes.string,
      action: PropTypes.string,
      query: PropTypes.object,
    }),
    loading: PropTypes.bool,
    // bobForms: PropTypes.shape({
    //   data: PropTypes.array,
    // }),
    templates: PropTypes.shape({
      token: PropTypes.string,
      data: PropTypes.shape({
        print: PropTypes.array,
        saleschart: PropTypes.array,
        accessibleIn: PropTypes.array,
      }),
    }),
    salesChartTypes: PropTypes.shape({
      data: PropTypes.array,
    }),
    addressSettings: PropTypes.shape({
      data: PropTypes.array,
    }),
    financeSources: PropTypes.shape({
      data: PropTypes.array,
    }),
    token: PropTypes.string,
    newFetch: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
    auth: state.auth,
    // bobForms: state.bobForms,
    templates: state.templates,
    salesChartTypes: state.salesChartTypes,
    addressSettings: state.addressSettings,
    financeSources: state.financeSources,
  })
  static defaultValues = {
    id: '',
    code: '',
    name: '',
    shortName: '',
    referenceCode: '',
    phonePrefix: '60',
    phone: '',
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    address5: '',
    address6: '',
    address7: '',
    address8: '',
    address9: '',
    address10: '',
    city: '',
    postcode: '',
    state: '',
    region: '',
    township: '',
    agencyAllocationAllocateAll: false,
    country: 'my',
    ownershipType: 'leasehold',
    propertyCategoryID: 'apartment',
    isCommercial: false,
    isIndustrial: false,
    isResidential: false,
    foreignPurchaseThreshold: FOREIGN_PURCHASE_THRESHOLD_DEFAULT,
    overviewTitle: '',
    overviewSubTitle: '',
    overview: '',
    specifications: [],
    options: [],
    mappings: [],
    manualPrice: false,
    minPrice: 0,
    maxPrice: 0,
    manualSize: false,
    minSize: 0,
    maxSize: 0,
    sizeSuffix: 'square_feet',
    loanTrackerProjectConsentTypeID: '2',
    newBookingEmailNotifications: [],
    approvedBookingEmailNotifications: [],
    cancelledBookingEmailNotifications: [],
    soldStatusBookingEmailNotifications: [],
    bookingUnitLimit: 1,
    statusID: 'draft',
    salesChartType: 'position',
    salesChartTemplate: 'default',
    siteplanID: '',
    siteplan: {},
    siteplanSettings: {},
    printType: 'none',
    sharedToBankerForms: [],
    printSPAType: 'none',
    printTerminationType: 'none',
    printClause: '',
    maOwnerCompanyBranchID: 0,
    maOwnerCompanyBranchShortName: '',
    loanTrackerDirectShow: true,
    loanTrackerProjectLeadBankersLimit: 6,
    isLaunchMode: false,
    launchModeMinutes: 0,
    defaultCustomBookingStatusID: 'reserved',
    defaultBumiProjectPricingID: '',
    defaultProjectPricingID: '',
    projectPricings: [],
    logoID: '',
    logo: null,
    salesChartRefreshSeconds: 120,
    customWatermark: '',
    linkBuyerApp: false,
    companyName: '',
    companyRegistrationNo: '',
    companyAddress: '',
    companyContactNo1: '',
    companyContactNo2: '',
    companyEmail: '',
    companyOthers: '',
    arBookingExpMoreThanMinutes: '',
    bapIsEnabled: false,
    bapIsProjectMode: false,
    bapMaxAttempts: 3,
    bapWindowMinutes: 30,
    bapCooldownMinutes: 180,
    bnReadAccessGroupIDs: defaultBookingNoteAccesses,
    bnWriteAccessGroupIDs: defaultBookingNoteAccesses,
    bnDefaultPrivacy: 'public',
    rduAccessGroupIDs: defaultRduAccesses,
    paymentReceiptAccessGroupIDs: defaultPaymentReceiptAccesses,
    cuRoleAccesses: [],
    requireValidTinAtBookingCreation: false,
    requireValidTinAtBookingAndSold: false,
    requireValidTinAtSold: false,
    tinSettingBookingStartAt: null,
    allowEditConversionDetailsIsEnabled: false,
    // CPI-974 item 18: statuses that need an approved payment. Empty for every existing project.
    paymentApprovedRequiredStatusIDs: [],
    // CPI-976: Reserved -> Booked needs the purchaser's signature. False for every project today.
    signatureRequiredForBooked: false,
    // Pre-Sales Launch: the roles blocked from reserving and from the Storey Plan. Empty = nobody.
    reserveDisabledRoleIDs: [],
    salesChartDisabledRoleIDs: [],
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    const user = props.auth;
    if (user && isForeignCompany(user.company)) {
      const idx = INTL_FLAG_CODES.findIndex(f => f.countryCode === user.company.countryCode);
      if (idx !== -1) {
        ProjectForm.defaultValues.phonePrefix = INTL_FLAG_CODES[idx].value;
        ProjectForm.defaultValues.country = INTL_FLAG_CODES[idx].countryCode;
      }
    }

    const oriProject = Object.assign({}, ProjectForm.defaultValues, props.project || {});

    if (!props.project) {
      oriProject.maOwnerCompanyBranchID = user.companyBranch.id;
      oriProject.maOwnerCompanyBranchShortName = user.companyBranch.shortName;
    }
    if (!oriProject.manualPrice) {
      oriProject.minPrice = oriProject.summary ? oriProject.summary.minPrice : 0;
      oriProject.maxPrice = oriProject.summary ? oriProject.summary.maxPrice : 0;
    }
    if (!oriProject.manualSize) {
      oriProject.minSize = oriProject.summary ? oriProject.summary.minSize : 0;
      oriProject.maxSize = oriProject.summary ? oriProject.summary.maxSize : 0;
    }
    oriProject.srbStoreyPlanExpiryMinutes = initialSRBExpiry(oriProject);
    oriProject.foreignPurchaseThreshold =
      foreignPurchaseThresholdOrDefault(oriProject.foreignPurchaseThreshold);
    if (!oriProject.specifications) {
      oriProject.specifications = [];
    }
    if (!oriProject.mappings) {
      oriProject.mappings = [];
    }
    if (!oriProject.options) {
      oriProject.options = [];
    }
    if (!oriProject.siteplanSettings) {
      oriProject.siteplanSettings = {};
    }
    if (oriProject.printType === '') {
      oriProject.printType = 'none';
    }
    if (!Array.isArray(oriProject.sharedToBankerForms)) {
      oriProject.sharedToBankerForms = [];
    }
    if (oriProject.printSPAType === '') {
      oriProject.printSPAType = 'none';
    }
    if (oriProject.printTerminationType === '') {
      oriProject.printTerminationType = 'none';
    }
    if (oriProject.salesChartTemplate === '') {
      oriProject.salesChartTemplate = 'default';
    }
    if (oriProject.bapWindowMinutes) {
      oriProject.bapWindowMinutes = oriProject.bapWindowMinutes.toString();
    }
    if (oriProject.bapCooldownMinutes) {
      oriProject.bapCooldownMinutes = oriProject.bapCooldownMinutes.toString();
    }
    const menuIsTab = window.innerWidth >= 991;
    const menuIsVertical = window.innerWidth >= 991;
    // const bForms = props.bobForms && props.bobForms.data
    //   ? [].concat(props.bobForms.data).sort((a, b) => a.title.localeCompare(b.title)) : [];
    // const bobForms = props.templates && props.templates.data && props.templates.data.print && bForms
    //   ? bForms.map(t => ({
    //     value: t.id,
    //     text: t.title,
    //   })) : [];
    const formAccessibilitiesTemplateIDs = props.project && props.project.projectFormAccessibilities && props.project.projectFormAccessibilities.length > 0 ?
      props.project.projectFormAccessibilities.map(p => p.templateID) : [];
    const pTemplates = props.templates && props.templates.data && props.templates.data.print ?
      [].concat(props.templates.data.print)
      .sort((a, b) => a.name.localeCompare(b.name)) : [];
    const printTemplates = props.templates && props.templates.data && props.templates.data.print && pTemplates ?
      pTemplates
      .map(t => ({
        value: t.id,
        text: t.name,
      })) : [];
    const printLoanReminderTemplates = props.templates && props.templates.data && props.templates.data.loan_reminder ?
      [].concat(props.templates.data.loan_reminder).map(t => ({
        value: t.id,
        text: t.name,
      })) : [];
    const printSPAReminderTemplates = props.templates && props.templates.data && props.templates.data.spa_reminder ?
      [].concat(props.templates.data.spa_reminder).map(t => ({
        value: t.id,
        text: t.name,
      })) : [];
    const printTerminationTemplates = props.templates && props.templates.data && props.templates.data.termination ?
      [].concat(props.templates.data.termination).map(t => ({
        value: t.id,
        text: t.name,
      })) : [];
    const salesChartTemplates = props.templates && props.templates.data &&
      props.templates.data.saleschart ? [].concat(props.templates.data.saleschart).map(t => ({
        value: t.id,
        text: t.name,
      })) : [];
    const salesChartTypes = props.salesChartTypes ?
      [].concat(props.salesChartTypes.data).map(({ value, text }) => {
        if (value !== 'disabled' && value !== 'custom' && value !== 'saleschart-app') {
          return ({
            text: props.t('Pivoted by {{text}}', { text: props.t(text) }),
            value,
          });
        }
        return ({ text, value });
      }) : [];
    const token = props.token;
    if (oriProject && (!oriProject.sourceOfFinanceOptions || oriProject.sourceOfFinanceOptions.length === 0)) {
      oriProject.sourceOfFinanceOptions = getDefaultProjectSourceOfFinanceOptions();
    }
    const defaultRTSetting = { priceMinor: 0, validityDurationDays: 0, limitPerOpportunity: 0, currencyCode: 'MYR' };
    const projectReservationTokenSetting = {
      ...defaultRTSetting,
      ...(props.project && props.project.unitReservationTokenSetting ? props.project.unitReservationTokenSetting : {}),
    };
    return {
      loading,
      project: clone(oriProject),
      srbExpiryEdited: false,
      oriProject,
      formAccessibilitiesTemplateIDs,
      menuIsTab,
      menuIsVertical,
      // bForms,
      // bobForms,
      pTemplates,
      printTemplates,
      printLoanReminderTemplates,
      printSPAReminderTemplates,
      printTerminationTemplates,
      salesChartTemplates,
      salesChartTypes,
      token,
      projectReservationTokenSetting,
      oriProjectReservationTokenSetting: clone(projectReservationTokenSetting),
    };
  }
  constructor(props) {
    super(props);
    const state = ProjectForm.getPropsToState(props);
    const tabs = this.buildTabs(props);
    let currentTab = tabs[0].name;
    if (props.location && props.location.hash.length > 0) {
      currentTab = props.location.hash.replace('#', '');
    }
    this.state = {
      ...state,
      tabs,
      currentTab,
      errMessages: [],
      genericErrMsg: props.t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }),
      siteplanHasSvg: false,
      siteplanHasImage: false,
      bookingCustomerSuccessEmailTemplates: [],
      openModal: false,
      openTncModal: false,
      systemData: [],
      templatesToken: '',
      isVisible: false,
      companyHimsTokens: [],
      companyHimsTokensLoading: false,
      compulsoryValidTinBeforeUpdateBooking: false,
    };
    this.validation = {
      country: createRef(),
      statusID: createRef(),
      name: createRef(),
      shortName: createRef(),
      referenceCode: createRef(),
      phone: createRef(),
      ownershipType: createRef(),
      propertyCategoryID: createRef(),
      minPrice: createRef(),
      maxPrice: createRef(),
      minSize: createRef(),
      maxSize: createRef(),
      sizeSuffix: createRef(),
      companyEmail: createRef(),
      launchModeMinutes: createRef(),
      creditControlIsUnlinked: createRef(),
      isCreditControlRebateUpdateDisabled: createRef(),
      loanTrackerProjectConsentTypeID: createRef(),
      newBookingEmailNotifications: createRef(),
      approvedBookingEmailNotifications: createRef(),
      cancelledBookingEmailNotifications: createRef(),
      soldStatusBookingEmailNotifications: createRef(),
      bookingUnitLimit: createRef(),
      defaultBookingFeeAmount: createRef(),
      minBookingPaymentAmount: createRef(),
      newPaymsBillplzSercetKey: createRef(),
      newPaymsBillplzSignatureKey: createRef(),
      paymsBillplzCollectionID: createRef(),
      paymsBillplzCollectionTitle: createRef(),
      newPaymsIPay88MerchantCode: createRef(),
      newPaymsIPay88MerchantKey: createRef(),
      newPaymentApprovalEmailNotifications: createRef(),
      newPaymentSuccessEmailNotifications: createRef(),
      mpAllowESignFormAtReserve: createRef(),
      accessBULNettSellingPrice: createRef(),
      accessStaffNettSellingPrice: createRef(),
      bapMaxAttempts: createRef(),
      himsStrataIsEnabled: createRef(),
      himsStrataIsHidden: createRef(),
      himsDefaultSpaLawyerRepID: createRef(),
      customerReservationMaxLimit: createRef(),
      foreignPurchaseThreshold: createRef(),
      srbStoreyPlanExpiryMinutes: createRef(),
      cuRoleAccesses: createRef(),
      address8: createRef(),
      address9: createRef(),
    };
    this.rtValidation = {
      rtPriceMinor: createRef(),
      rtValidityDurationDays: createRef(),
      rtLimitPerOpportunity: createRef(),
    };
    // add validateRef for all enabled address settings
    const enabledAddressSettings = props.addressSettings.data.filter(as => as.enabled);
    if (enabledAddressSettings && enabledAddressSettings.length > 0) {
      enabledAddressSettings.forEach((as) => {
        const key = _.camelCase(as.columnName);
        this.validation[key] = createRef();
      });
    }
    this.uploadForm = {};
    this.uploadModal = {};
    this.himsSettingsForm = createRef();
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchTemplates('print', true));
    store.dispatch(fetchTemplates('loan_reminder', true));
    store.dispatch(fetchTemplates('spa_reminder', true));
    store.dispatch(fetchTemplates('termination', true));
    store.dispatch(fetchTemplates('saleschart', true));
    store.dispatch(fetchSalesChartTypes(true));
    // store.dispatch(fetchBobForms(true));
  }
  componentDidMount() {
    this.fetchBookingCustomerSuccessEmailTemplates();
    this.fetchSystemSettings();
    this.fetchTemplateP();
    window.addEventListener('resize', this.handleResize, false);

    if (this.hasCompanyHimsEnabled()) {
      this.fetchCompanyHimsTokens();
    }
  }
  componentWillReceiveProps(nextProps) {
    // only load svg on sales chart setup tab
    let currentTab = this.state.currentTab;
    if (currentTab === 'sales_chart_setup') {
      const state = ProjectForm.getPropsToState(nextProps);
      this.checkSiteplan(state);
    }

    // do not fetch if hashtag changed
    if (this.props.location.hash !== nextProps.location.hash && nextProps.location.action === 'REPLACE') return;

    if (JSON.stringify(this.props.addressSettings.data) !== JSON.stringify(nextProps.addressSettings.data)) {
      // add validateRef for all enabled address settings
      const enabledAddressSettings = nextProps.addressSettings.data.filter(as => as.enabled);
      if (enabledAddressSettings && enabledAddressSettings.length > 0) {
        enabledAddressSettings.forEach((as) => {
          const key = _.camelCase(as.columnName);
          this.validation[key] = createRef();
        });
      }
    }

    // update state
    const state = ProjectForm.getPropsToState(nextProps);
    const compulsoryValidTinBeforeUpdateBooking = state.oriProject.requireValidTinAtBookingAndSold || state.oriProject.requireValidTinAtSold;
    let tinDropdown = '';
    if (state.oriProject.requireValidTinAtBookingAndSold) {
      tinDropdown = 'booked_and_sold';
    } else if (state.oriProject.requireValidTinAtSold) {
      tinDropdown = 'sold';
    }
    if (JSON.stringify(state.oriProject) === JSON.stringify(this.state.oriProject)) {
      state.project = this.state.project;
      state.srbExpiryEdited = this.state.srbExpiryEdited;
      state.formAccessibilitiesTemplateIDs = this.state.formAccessibilitiesTemplateIDs;
      state.projectReservationTokenSetting = this.state.projectReservationTokenSetting;
      state.oriProjectReservationTokenSetting = this.state.oriProjectReservationTokenSetting;
    }
    if (
      !this.hasUpdateAccess() &&
      nextProps.auth.company.companyCurrency
      && !this.state.project.projectCurrency) {
      this.setProjectCurrency();
    }
    if (nextProps.location && nextProps.location.hash.length > 0) {
      currentTab = nextProps.location.hash.replace('#', '');
    }
    const tabs = this.buildTabs(nextProps);
    this.setState({
      ...state,
      tinDropdown,
      compulsoryValidTinBeforeUpdateBooking,
      tabs,
      currentTab,
    }, () => {
      if (
        this.hasCompanyHimsEnabled(nextProps) &&
        !this.state.companyHimsTokensLoading &&
        this.state.companyHimsTokens && this.state.companyHimsTokens.length === 0
      ) {
        this.fetchCompanyHimsTokens();
      }
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setProjectCurrency() {
    const { companyCurrency = [] } = this.props.auth.company;
    const { project } = this.state;
    project.projectCurrency = companyCurrency.map((c) => {
      const currency = Object.assign({}, c);
      delete currency.id;
      delete currency.companyId;
      return currency;
    });
    this.setState({ project });
  }
  getSiteplanToken() {
    const { project } = this.state;
    const { store } = this.context;
    return store.dispatch(fetchM(`/projects/${project.id}/siteplans/${project.siteplan.id}/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then((res) => {
        const token = res.headers.get('X-Csrf-Token');
        return token;
      });
  }
  getSelectedBranchValue = () => {
    const { project } = this.state;
    const selectedBranchValue = {
      key: project.maOwnerCompanyBranchID.toString() || 0,
      title: project.maOwnerCompanyBranchShortName || '',
    };
    return selectedBranchValue;
  }
  setLoading = (loading = false) => (new Promise((res) => {
    this.setState({ loading }, res);
  }))
  setCompanyHimsTokensLoading = (companyHimsTokensLoading = false) => (new Promise((res) => {
    this.setState({ companyHimsTokensLoading }, res);
  }))
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  async getLogoToken() {
    const { store } = this.context;
    const { t } = this.props;
    let res;
    let token;
    try {
      res = await store.dispatch(fetchM('/logos/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return null;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      token = res.headers.get('X-Csrf-Token');
      // handle token.. etc
    }
    return token;
  }
  handleOnVisible = (bool) => {
    this.setState({ isVisible: bool });
  }
  handleDateTimeInputChange = (value, visible) => {
    const { project } = this.state;
    let { isVisible } = this.state;
    const hoursLeft = moment.duration(moment(value).diff(moment())).asHours();
    isVisible = visible;
    if (!visible) {
      this.setState({ isVisible });
      return;
    }
    if (hoursLeft < 0) {
      // A past date means no event: clear it explicitly - Math.floor(moment().format()) is NaN.
      project.mpBuyerEventLaunchAt = null;
    } else if (hoursLeft > 0) {
      project.mpBuyerEventLaunchAt = moment(value).format();
    }
    this.setState({ project, isVisible }, () => {
      this.handleCheckChanges();
    });
  }
  handleTinSettingDateTimeInputChange = (value) => {
    const { project } = this.state;
    project.tinSettingBookingStartAt = moment(value).format();
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  getCountdownFormat = (mpBuyerEventLaunchAt) => {
    const hoursLeft = moment.duration(moment(mpBuyerEventLaunchAt).diff(moment())).asHours();
    const daysLeft = moment.duration(moment(mpBuyerEventLaunchAt).diff(moment())).asDays();
    return {
      day: daysLeft > 0 ? 'ddd' : '00',
      hour: hoursLeft < 0 ? 'HH' : '00',
      minute: 'mm',
      second: 'ss',
    };
  }
  resetEventTimer = () => {
    const { project } = this.state;
    project.mpBuyerEventLaunchAt = null;
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  async uploadSiteplan(e, body) {
    e.preventDefault();
    await this.setLoading(true);
    const { store } = this.context;
    const { project } = this.state;
    const { t } = this.props;
    try {
      await this.uploadForm.siteplan.submit(`/projects/${project.id}/siteplans/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': this.state.token,
        },
        body,
      });
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.uploadModal.siteplan.close();
    await this.setLoading(false);
    store.dispatch(push(`/projects/${project.id}/edit/${this.props.location.hash}`));
    store.dispatch(flashSuccessMessage({
      header: t('Upload Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Siteplan successfully uploaded', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  async replaceSiteplan(e, body, type) {
    e.preventDefault();
    await this.setLoading(true);
    const { store } = this.context;
    const { project } = this.state;
    const { t } = this.props;
    const token = await this.getSiteplanToken();
    try {
      if (this.uploadForm[type]) {
        await this.uploadForm[type].submit(`/projects/${project.id}/siteplans/${project.siteplan.id}/`, {
          credentials: 'include',
          method: 'POST',
          headers: {
            // Let browser decide Content-Type
            'X-Csrf-Token': token,
          },
          body,
        });
      }
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    if (this.uploadModal[type]) {
      this.uploadModal[type].close();
    }
    await this.setLoading(false);
    store.dispatch(push(`/projects/${project.id}/edit/${this.props.location.hash}`));
    store.dispatch(flashSuccessMessage({
      header: t('Upload Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Siteplan successfully replaced', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  checkSiteplan(state = this.state) {
    const { oriProject } = state;
    if (oriProject.siteplan && oriProject.siteplan.id && oriProject.siteplan.key) {
      const { siteplan } = oriProject;
      this.checkSvg(siteplanUrl(this.props.appConfig, `${siteplan.key}.svg`));
      this.checkImage(siteplanUrl(this.props.appConfig, `${siteplan.key}.jpg`));
    }
  }
  async fetchBookingCustomerSuccessEmailTemplates() {
    const { store } = this.context;
    const { t } = this.props;
    let res = null;
    const q = Object.assign({
      limit: 0,
      templateType: 'customer_booking_success',
    });
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/templates/?${qs.stringify(q)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return null;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return null;
    }
    const json = await res.json();
    if (json) {
      const bookingCustomerSuccessEmailTemplates = json.map((obj) => {
        const newResults = {};
        newResults.value = obj.id;
        newResults.text = obj.name;
        return newResults;
      });
      await this.setComponentState({ bookingCustomerSuccessEmailTemplates });
    }
    return null;
  }
  async fetchSystemSettings() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const systemData = await res.json();
      const state = { systemData };
      if (!this.state.project.id) {
        const agencyAllocationAllocateAll = Boolean(systemData.agencyAllocationAllocateAll);
        // keep the fetched default when new-project state is rebuilt from defaultValues
        ProjectForm.defaultValues.agencyAllocationAllocateAll = agencyAllocationAllocateAll;
        state.project = { ...this.state.project, agencyAllocationAllocateAll };
        state.oriProject = { ...this.state.oriProject, agencyAllocationAllocateAll };
      }
      await this.setComponentState(state);
    }
    await this.setLoading(false);
  }
  async fetchTemplateP() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    const q = Object.assign({
      templateType: 'print',
    });
    try {
      res = await store.dispatch(fetchM(`/templates/?${qs.stringify(q)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const templatesToken = res.headers.get('X-CSRF-Token');
      await this.setComponentState({
        templatesToken,
      });
    }
    await this.setLoading(false);
  }
  async fetchCompanyHimsTokens() {
    await this.setCompanyHimsTokensLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM('/company_hims_tokens/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setCompanyHimsTokensLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const companyHimsTokens = await res.json();
      await this.setComponentState({
        companyHimsTokens,
      });
    }
    await this.setCompanyHimsTokensLoading(false);
  }
  async deletePricingTier(id) {
    await this.setLoading(true);
    const { store } = this.context;
    const { project } = this.state;
    const { t } = this.props;
    const data = project.projectPricings.filter(d => d.id !== id);
    const item = project.projectPricings.find(d => d.id === id);
    try {
      await store.dispatch(fetchM(`/projects/${project.id}/pricing_tiers/${id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({
      header: t('Discount Package Deleted', { ns: TRANSLATION_FILES.translation }),
      message: t('{{item}} was successfully removed', { item: item.name, ns: TRANSLATION_FILES.translation }),
    }));
    project.projectPricings = data;
    this.setState({ project }, () => {
      this.handleCheckChanges();
      this.props.newFetch();
    });
  }
  hasAccess(admin = true, dhq = true, dbl = true, dbls = false, adminBasic = false) {
    if (admin && this.props.auth.isSuperAdmin) {
      return true;
    }
    if (adminBasic && this.props.auth.isAdminBasic) {
      return true;
    }
    if (dhq && this.props.auth.isHeadquarters) {
      return true;
    }
    if (dbl && this.props.auth.isBranchLeader) {
      return true;
    }
    if (dbls && this.props.auth.isBranchLeaderSupervisorII) {
      return true;
    }
    return false;
  }
  hasCompanyHimsEnabled = (props = this.props) => {
    const { appConfig } = props;
    const companyHimsIsEnabled = appConfig && appConfig.data && appConfig.data.himsIsEnabled;
    return this.hasAccess(true, true, true, false, true) && companyHimsIsEnabled;
  }
  hasCompanyQuotationEnabled = (props = this.props) => {
    const { appConfig } = props;
    const companyQuotationIsEnabled = appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.generateQuotationIsEnabled;
    return this.hasAccess(true, true, true) && companyQuotationIsEnabled;
  }
  checkSvg = (url, isRetry = false) => {
    const request = new XMLHttpRequest();
    request.open('GET', url);
    request.setRequestHeader('Content-Type', 'image/svg+xml');
    request.onload = () => {
      if (request.status !== 200) {
        if (!isRetry) {
          const { oriProject } = this.state;
          const svgUrl = siteplanUrl(this.props.appConfig, `${oriProject.siteplan.key}${oriProject.siteplan.svgUploadedAt ? `_${moment(oriProject.siteplan.svgUploadedAt).format('YYYYMMDDHHmmss')}` : ''}.svg`);
          // retry once
          this.checkSvg(svgUrl, true);
          return;
        }
        this.setState({ siteplanHasSvg: false });
        return;
      }
      this.setState({ siteplanHasSvg: true });
    };
    request.onerror = () => {
      this.setState({ siteplanHasSvg: false });
    };
    request.send();
  }
  formatVND = (val) => {
    if (val === undefined || val === null || val === '') return '';
    const stringVal = val.toString().replace(/\D/g, '');
    return stringVal.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  checkImage = (url, isRetry = false) => {
    const image = new Image();
    image.src = url;
    image.onload = () => {
      this.setState({ siteplanHasImage: true });
    };
    image.onerror = () => {
      if (!isRetry) {
        const { oriProject } = this.state;
        const imgUrl = siteplanUrl(this.props.appConfig, `${oriProject.siteplan.key}${oriProject.siteplan.imageUploadedAt ? `_${moment(oriProject.siteplan.imageUploadedAt).format('YYYYMMDDHHmmss')}` : ''}.jpg`);
        // retry once
        this.checkImage(imgUrl, true);
        return;
      }
      this.setState({ siteplanHasImage: false });
    };
  }
  checkCountryIsMalaysia = (country) => {
    if (country) {
      if (country.toLowerCase() === 'my') {
        return true;
      }
    }
    return false;
  }
  handleResize = () => {
    const state = {};
    const menuIsTab = window.innerWidth >= 991;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    const menuIsVertical = window.innerWidth >= 991;
    if (menuIsVertical !== this.state.menuIsVertical) {
      state.menuIsVertical = menuIsVertical;
    }
    this.setState({ ...state });
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  async bulkUpsertAndDeleteProjectFormAccessibilities() {
    const { store } = this.context;
    const { t } = this.props;
    const { formAccessibilitiesTemplateIDs, project } = this.state;
    let pendingUpsertPFAs = [];
    if (formAccessibilitiesTemplateIDs && formAccessibilitiesTemplateIDs.length > 0) {
      let projectFAs = [];
      if (project && project.projectFormAccessibilities && project.projectFormAccessibilities.length > 0) {
        projectFAs = project.projectFormAccessibilities;
      }
      pendingUpsertPFAs = formAccessibilitiesTemplateIDs.map((templateID) => {
        const pfaIdx = projectFAs.findIndex(p => p.templateID === templateID);
        if (pfaIdx !== -1) {
          return projectFAs[pfaIdx];
        }
        return {
          projectID: project.id,
          templateID,
          companyBranchIDs: [],
          companyBranchAwsIDs: [],
          isEnabledOnReserved: true,
          isEnabledOnBooked: true,
          isEnabledOnSold: true,
          isVisibleToLawyer: true,
        };
      });
    }
    try {
      await store.dispatch(fetchM(`/projects/${project.id}/form_accessibilities/bulk/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(pendingUpsertPFAs),
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage(t('An error occured', { ns: TRANSLATION_FILES.translation })));
    }
  }
  handleSubmit = async (event) => {
    const { store } = this.context;
    const { t } = this.props;
    if (event) event.preventDefault();
    const { project, srbExpiryEdited } = this.state;
    const srbVietnam = isCountryVietnam(this.props.auth && this.props.auth.company && this.props.auth.company.countryCode);
    const srbExpiry = srbExpirySubmission(project, srbExpiryEdited, srbVietnam && this.props.auth.isHeadquarters && this.buyerMarketplaceHasAccess());
    if (srbExpiry.block) {
      const message = t('Enter a whole number from 1 to 30 minutes.');
      this.setState({ errMessages: [{ key: 'srbStoreyPlanExpiryMinutes', isValid: false, message }] });
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: [message] }));
      this.setLoading(false);
      return;
    }
    // Reject invalid VN thresholds before any save side effects or state mutation.
    const foreignPurchaseThreshold =
      foreignPurchaseThresholdSubmission(this.props.auth, project.foreignPurchaseThreshold);
    if (foreignPurchaseThreshold.block) {
      const [validity] = await AppForm.validate(
        { foreignPurchaseThreshold: this.validation.foreignPurchaseThreshold },
        project,
      );
      // the ref is mounted whenever the section is rendered; the literal is only so a blocked save
      // can never flash an empty list.
      const errMessages = validity && !validity.isValid ? [validity] : [{
        key: 'foreignPurchaseThreshold',
        isValid: false,
        message: t('Enter a value from 0–100. Only numeric input is accepted.'),
      }];
      this.setState({ errMessages });
      store.dispatch(flashErrorMessage({
        header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }),
        list: errMessages.map(l => l.message),
      }));
      this.setLoading(false);
      return;
    }
    if (project && project.id) await this.bulkUpsertAndDeleteProjectFormAccessibilities();
    if (project && project.id) {
      const { projectReservationTokenSetting, oriProjectReservationTokenSetting } = this.state;
      if (JSON.stringify(projectReservationTokenSetting) !== JSON.stringify(oriProjectReservationTokenSetting)) {
        const rtSaved = await this.saveReservationTokenSettings(true);
        if (rtSaved === false) return;
      }
    }
    if (project.projectPricings && project.projectPricings.length > 0) {
      project.projectPricings = project.projectPricings.filter(d => d.name !== '' || d.formulaPrice !== '');
    }
    if (project.specifications) {
      project.specifications = project.specifications.filter(data =>
        data.name.length > 0 && data.value.length > 0).map((data, idx) => ({
          ...data,
          position: idx + 1,
        }));
    }
    if (project.mappings) {
      project.mappings = project.mappings.filter(data =>
        data.name.length > 0 && data.value.length > 0).map((data, idx) => ({
          ...data,
          position: idx + 1,
        }));
    }
    if (project.options) {
      project.options = project.options.filter(data =>
        data.name.length > 0 && data.value.length > 0).map((data, idx) => ({
          ...data,
          position: idx + 1,
        }));
    }
    if (project.printType === 'none') {
      project.printType = '';
    }
    if (project.printSPAType === 'none') {
      project.printSPAType = '';
    }
    if (project.printTerminationType === 'none') {
      project.printTerminationType = '';
    }
    if (project.salesChartTemplate === 'default') {
      project.salesChartTemplate = '';
    }
    project.sharedToBankerForms = _.uniq((project.sharedToBankerForms || []).filter(Boolean));
    if (project.projectFormAccessibilities && project.projectFormAccessibilities.length === 0) {
      project.printPDF = false;
    }
    if (project.projectBookingCustomFields && project.projectBookingCustomFields.length > 0) {
      // set bookingCustomFields multi_dropdown default value
      const bcfs = [...project.projectBookingCustomFields];
      if (bcfs && bcfs.length > 0) {
        const hasMultiDropdown = bcfs.findIndex(bcf => bcf.type === 'dropdown_multi');
        if (hasMultiDropdown !== -1) {
          let i = 0;
          while (i < bcfs.length) {
            if (bcfs[i].type === 'dropdown_multi') {
              let defaultValue = '';
              if (_.isArray(bcfs[i].defaultValue)) {
                defaultValue = bcfs[i].defaultValue.filter(v => v !== '').join(',');
              }
              bcfs[i].defaultValue = defaultValue;
            }
            i += 1;
          }
        }
      }
      project.projectBookingCustomFields = bcfs;
    }
    let himsValidations = [];
    if (project.projectHimsSettings && project.projectHimsSettings.length > 0 && this.himsSettingsForm && this.himsSettingsForm.current) {
      himsValidations = await this.himsSettingsForm.current.validate();
    }
    if (project.paymentTypeOptions && project.paymentTypeOptions.length < 1) {
      store.dispatch(flashErrorMessage({ message: t('There must be at least ONE Payment Method enabled', { ns: TRANSLATION_FILES.translation }) }));
      this.setLoading(false);
      return;
    }
    if (project.minPrice % 1 !== 0 || project.maxPrice % 1 !== 0) {
      store.dispatch(flashErrorMessage({ message: t('Minimum and Maximum price should not contain decimal points', { ns: TRANSLATION_FILES.translation }) }));
      this.setLoading(false);
      return;
    }
    AppForm.validate(this.validation, project)
      .then((validations) => {
        const allValidations = [].concat(validations, himsValidations);
        this.setState({
          errMessages: allValidations.filter(v => !v.isValid),
        });
        const data = Object.assign({}, project, {
          minPrice: project.manualPrice ? parseFloat(project.minPrice) : 0,
          maxPrice: project.manualPrice ? parseFloat(project.maxPrice) : 0,
          minSize: project.manualSize ? parseFloat(project.minSize) : 0,
          maxSize: project.manualSize ? parseFloat(project.maxSize) : 0,
          bookingUnitLimit: project.bookingUnitLimit ? parseFloat(project.bookingUnitLimit) : 1,
          defaultBookingFeeAmount: project.defaultBookingFeeAmount ? parseFloat(project.defaultBookingFeeAmount) : 0,
          minBookingPaymentAmount: project.minBookingPaymentAmount ? parseFloat(project.minBookingPaymentAmount) : 0,
          loanTrackerProjectLeadBankersLimit: project.loanTrackerProjectLeadBankersLimit ?
            parseInt(project.loanTrackerProjectLeadBankersLimit, 10) : 0,
          launchModeMinutes: project.launchModeMinutes ?
            parseInt(project.launchModeMinutes, 10) : 0,
          bapMaxAttempts: parseInt(project.bapMaxAttempts, 10),
          bapWindowMinutes: parseInt(project.bapWindowMinutes, 10),
          bapCooldownMinutes: parseInt(project.bapCooldownMinutes, 10),
          customerReservationMaxLimit: project.customerReservationMaxLimit ? parseInt(project.customerReservationMaxLimit, 10) : 1,
        });
        if (srbExpiry.omit) {
          delete data.srbStoreyPlanExpiryMinutes;
        } else {
          data.srbStoreyPlanExpiryMinutes = srbExpiry.value;
        }
        if (foreignPurchaseThreshold.omit) {
          delete data.foreignPurchaseThreshold;
        } else {
          data.foreignPurchaseThreshold = foreignPurchaseThreshold.value;
        }
        this.props.onSubmit(allValidations, data);
      });
    this.setState({ openModal: false });
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      this.props.onChange(true);
    }
  }
  handleSubmitBankerFormTemplate = (value) => {
    const { oriProject, project } = this.state;
    const payload = _.isObject(value) ? value : {};
    if (Object.prototype.hasOwnProperty.call(payload, 'printType')) {
      oriProject.printType = payload.printType || '';
      project.printType = payload.printType || '';
    }
    if (Object.prototype.hasOwnProperty.call(payload, 'sharedToBankerForms')) {
      const nextSharedToBankerForms = _.uniq((payload.sharedToBankerForms || []).filter(Boolean));
      oriProject.sharedToBankerForms = nextSharedToBankerForms;
      project.sharedToBankerForms = nextSharedToBankerForms;
    }

    if (oriProject.printSPAType === 'none') {
      oriProject.printSPAType = '';
    }
    if (oriProject.printTerminationType === 'none') {
      oriProject.printTerminationType = '';
    }
    if (oriProject.salesChartTemplate === 'default') {
      oriProject.salesChartTemplate = '';
    }
    if (oriProject.projectFormAccessibilities && oriProject.projectFormAccessibilities.length === 0) {
      oriProject.printPDF = false;
    }
    const data = Object.assign({}, oriProject, {
      minPrice: oriProject.manualPrice ? parseFloat(oriProject.minPrice) : 0,
      maxPrice: oriProject.manualPrice ? parseFloat(oriProject.maxPrice) : 0,
      minSize: oriProject.manualSize ? parseFloat(oriProject.minSize) : 0,
      maxSize: oriProject.manualSize ? parseFloat(oriProject.maxSize) : 0,
      bookingUnitLimit: oriProject.bookingUnitLimit ? parseFloat(oriProject.bookingUnitLimit) : 1,
      defaultBookingFeeAmount: oriProject.defaultBookingFeeAmount ? parseFloat(oriProject.defaultBookingFeeAmount) : 0,
      minBookingPaymentAmount: oriProject.minBookingPaymentAmount ? parseFloat(oriProject.minBookingPaymentAmount) : 0,
      loanTrackerProjectLeadBankersLimit: oriProject.loanTrackerProjectLeadBankersLimit ?
        parseInt(oriProject.loanTrackerProjectLeadBankersLimit, 10) : 0,
      launchModeMinutes: oriProject.launchModeMinutes ?
        parseInt(oriProject.launchModeMinutes, 10) : 0,
      bapMaxAttempts: parseInt(oriProject.bapMaxAttempts, 10),
      bapWindowMinutes: parseInt(oriProject.bapWindowMinutes, 10),
      bapCooldownMinutes: parseInt(oriProject.bapCooldownMinutes, 10),
    });
    this.setState({ oriProject, project }, () => {
      this.props.onSubmit([], data);
    });
  }
  handleCheckIfPublish(e) {
    const { marketplaceIsPublish, statusID } = this.props.project;
    const { project } = this.state;
    e.preventDefault();
    const isDeleted = project.statusID === 'draft' || project.statusID === 'archived' || project.statusID === 'deleted';
    if (marketplaceIsPublish && statusID === 'published' && isDeleted) {
      this.setState({ openModal: true });
    } else {
      this.handleSubmit(e);
    }
  }
  handleInputChange = (event, { name, value }) => {
    const { formAccessibilitiesTemplateIDs, project } = this.state;
    const srbExpiryEdited = this.state.srbExpiryEdited || name === 'srbStoreyPlanExpiryMinutes';
    let faTemplateIds = formAccessibilitiesTemplateIDs;
    const input = event.target;
    if (name === 'minPrice' || name === 'maxPrice') {
      const cursor = input.selectionStart;
      const cleanValue = value.replace(/\D/g, '');

      if (cleanValue.length > 15) return;

      this.setState({
        project: { ...project, [name]: cleanValue },
      }, () => {
        input.setSelectionRange(cursor, cursor);
        this.handleCheckChanges();
      });

      return;
    }
    if (name === 'formAccessibilitiesTemplateIDs') {
      faTemplateIds = value;
    } else {
      if (name === 'bnReadAccessGroupIDs' || name === 'bnWriteAccessGroupIDs' || name === 'rduAccessGroupIDs' || name === 'paymentReceiptAccessGroupIDs' ||
        name === 'reserveDisabledRoleIDs' || name === 'salesChartDisabledRoleIDs') {
        value.sort();
      }
      project[name] = value;
    }
    if (name === 'launchModeMinutes') {
      project.srbStoreyPlanExpiryMinutes = currentSRBExpiry(project, srbExpiryEdited);
    }
    if (name === 'cuRoleAccesses') {
      if (value.includes(CU_EXTERNAL_STAFF_ACCESS)) {
        project.cuAllowExternalReserved = true;
        project.cuAllowExternalBooked = false;
        project.cuDisableExtEditCancelCriteria = true;
      }
    }
    if (name === 'bnReadAccessGroupIDs' || name === 'bnWriteAccessGroupIDs' || name === 'rduAccessGroupIDs' || name === 'paymentReceiptAccessGroupIDs') {
      if (!value.includes(SR_ROLE_ID_DEVELOPER_HEADQUARTERS)) {
        value.unshift(SR_ROLE_ID_DEVELOPER_HEADQUARTERS);
        project[name] = value;
      }
    }
    if (name === 'bookingUnitLimit') {
      if (value <= 1) {
        project.activeBookingsInUnits = false;
        project.activeBookingsIncludeWaitlist = false;
      }
    }
    if (name === 'tinDropdown') {
      if (value === 'booked_and_sold' && !project.requireValidTinAtBookingAndSold) {
        project.requireValidTinAtBookingAndSold = true;
        project.requireValidTinAtSold = false;
      } else if (value === 'sold' && !project.requireValidTinAtSold) {
        project.requireValidTinAtBookingAndSold = false;
        project.requireValidTinAtSold = true;
      } else {
        project.requireValidTinAtBookingAndSold = false;
        project.requireValidTinAtSold = false;
      }
      this.setState({ tinDropdown: value });
    }
    this.setState({ formAccessibilitiesTemplateIDs: faTemplateIds, project, srbExpiryEdited }, () => {
      this.handleCheckChanges();
    });
  }
  handleConsentCheck = (event, data) => {
    const { project } = this.state;
    if (data.checked) {
      project[data.name] = '2';
    } else {
      project[data.name] = '1';
    }
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handleAddEmail = (event, value, key) => {
    const { store } = this.context;
    const { project } = this.state;
    const { t } = this.props;
    const r = new RegExp(RX_EMAIL, 'i');
    if (value.some(v => !r.test(v))) {
      store.dispatch(flashErrorMessage({ message: t('Invalid email address', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (project[key] &&
      project[key].some(eml => value.some(v => eml.text === v))) {
      store.dispatch(flashErrorMessage({ message: t('Duplicate email address', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    project[key] = value;
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handleCheckBoxChange = (event, data) => {
    const { project, oriProject } = this.state;
    project[data.name] = !project[data.name];
    if (data.name === 'isLaunchMode') {
      project.srbStoreyPlanExpiryMinutes = currentSRBExpiry(project, this.state.srbExpiryEdited);
    }
    if (data.name === 'manualPrice' && !project[data.name]) {
      project.minPrice = (project.summary ? project.summary.minPrice : oriProject.minPrice) || 0;
      project.maxPrice = (project.summary ? project.summary.maxPrice : oriProject.maxPrice) || 0;
    }
    if (data.name === 'manualSize' && !project[data.name]) {
      project.minSize = (project.summary ? project.summary.minSize : oriProject.minSize) || 0;
      project.maxSize = (project.summary ? project.summary.maxSize : oriProject.maxSize) || 0;
    }
    if (data.name === 'loanTrackerDirectShow' && !project[data.name]) {
      project.loanTrackerDirectConsent = false;
    }
    if (data.name === 'arBookingExpIsEnabled' && !project[data.name]) {
      project.arBookingExpUnpaidIsEnabled = false;
      project.arBookingExpNricPicIsEnabled = false;
      project.arBookingExpMortgageEnabled = false;
    }
    if (data.name === 'activeBookingsInUnits' && !project[data.name]) {
      project.activeBookingsIncludeWaitlist = false;
    }
    if (data.name === 'cuIsEnabled' && !project[data.name]) {
      project.cuOtherProjectIsEnabled = false;
      project.cuFollowPrevBookingDateIsEnabled = false;
      project.cuDefaultFollowPrevBookingDateIsEnabled = false;
      project.cuDisabledEditingOfFollowPrevBookingDate = false;
      project.cuAttachmentsRequired = false;
      project.cuReserveNewBooking = false;
      project.cuReactivatePrevBooking = false;
      project.cuAllowExternalReserved = false;
      project.cuAllowExternalBooked = false;
      project.cuDisableExtEditCancelCriteria = false;
    }
    if (data.name === 'cuFollowPrevBookingDateIsEnabled' && !project[data.name]) {
      project.cuDefaultFollowPrevBookingDateIsEnabled = false;
      project.cuDisabledEditingOfFollowPrevBookingDate = false;
    }
    if (data.name === 'cuDefaultFollowPrevBookingDateIsEnabled' && !project[data.name]) {
      project.cuDisabledEditingOfFollowPrevBookingDate = false;
    }
    if (data.name === 'cuReserveNewBooking' && !project[data.name]) {
      project.cuReactivatePrevBooking = false;
    }
    if (data.name === 'compulsoryValidTinBeforeUpdateBooking') {
      let compulsoryValidTinBeforeUpdateBooking = !this.state.compulsoryValidTinBeforeUpdateBooking;
      if (!compulsoryValidTinBeforeUpdateBooking) {
        compulsoryValidTinBeforeUpdateBooking = false;
        project.requireValidTinAtBookingAndSold = false;
        project.requireValidTinAtSold = false;
        project.tinSettingBookingStartAt = null;
      } else {
        const selected = this.state.tinDropdown;
        compulsoryValidTinBeforeUpdateBooking = true;
        if (selected === 'booked_and_sold') {
          project.requireValidTinAtBookingAndSold = true;
        } else if (selected === 'sold') {
          project.requireValidTinAtSold = true;
        }
      }
      this.setState({ compulsoryValidTinBeforeUpdateBooking }, () => {
        this.handleCheckChanges();
      });
    }
    if (data.name === 'tinSettingBookingStartAt') {
      project.tinSettingBookingStartAt = data.checked ? data.value : null;
    }
    if (data.name === 'creditControlIsUnlinked') {
      project.allowPurchaserEditAfterSold = project[data.name];
      project.allowPricingEditAfterSold = project[data.name];
      // if (project[data.name]) {
      //   project.autoGenerateBillingAfterSold = false;
      // }
    }
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handleFinanceSourcesCheckboxChange = (e, data) => {
    const { project } = this.state;
    let sourceOfFinanceOptions = [...project.sourceOfFinanceOptions];
    if (sourceOfFinanceOptions && sourceOfFinanceOptions.length > 0 && sourceOfFinanceOptions.includes(data.name)) {
      sourceOfFinanceOptions = sourceOfFinanceOptions.filter(option => option !== data.name);
    } else {
      sourceOfFinanceOptions.push(data.name);
    }
    project.sourceOfFinanceOptions = sourceOfFinanceOptions;
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handlePaymentTypeChange = (event, data) => {
    const { project } = this.state;
    if (data.name === 'cash' ||
    data.name === 'cheque' ||
    data.name === 'bank_transfer' ||
    data.name === 'credit_card' ||
    data.name === 'online_payment' ||
    data.name === 'others') {
      let paymentTypeOptions = [...project.paymentTypeOptions];
      if (paymentTypeOptions && paymentTypeOptions.length > 0 && paymentTypeOptions.includes(data.name)) {
        paymentTypeOptions = paymentTypeOptions.filter(option => option !== data.name);
      } else {
        paymentTypeOptions.push(data.name);
      }
      project.paymentTypeOptions = paymentTypeOptions;
    }
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handleNavigatePayment = (e, tab) => {
    e.preventDefault();
    this.setState({ currentTab: tab });
  }

  handleFlashMPCriteriaMsg = () => {
    const { store } = this.context;
    const { t } = this.props;
    store.dispatch(flashMessage({ message:
  <div>
    <Header
      as="h5"
    >
      {t('Kindly provide the following details to proceed')}:
      <div style={{ margin: '10px', fontWeight: 'normal' }}>
        <ul>
          <li>
            <Button
              className="flash-button"
              onClick={e => this.handleNavigatePayment(e, 'payment_setup')}
            >
              {t('Bank Accounts')}
            </Button>
          </li>
          <li>
            <Button
              className="flash-button"
              onClick={e => this.handleNavigatePayment(e, 'payment_setup')}
            >
              {t('Default Booking Fee')}
            </Button>
          </li>
          <li>
            <Button
              as={Link}
              className="flash-button"
              to={`/projects/${this.state.project.id}/documents/`}
            >
              {t('Document/E-Sales Kit')}
            </Button>
          </li>
          <li>
            <Button
              className="flash-button"
              onClick={e => this.handleNavigatePayment(e, 'marketplace')}
            >
              {t('Commission')}
            </Button>
          </li>
        </ul>
      </div>
    </Header>
  </div>,
      type: 'error',
    }));
  }
  handleSpecificationsChange = (data) => {
    const { project } = this.state;
    project.specifications = data;
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handleMappingChange = (data) => {
    const { project } = this.state;
    project.mappings = data;
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handleOptionChange = (data) => {
    const { project } = this.state;
    project.options = data;
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handleSiteplanSettingsChange = (event, { name, value, checked }) => {
    const { project } = this.state;
    if (name === 'overlayMode') {
      project.siteplanSettings[name] = value;
    } else {
      project.siteplanSettings[name] = (
        name === 'hideLayouts' ||
        name === 'salesChartSimpleMode' ||
        name === 'salesChartDelistedAsUnavailable' ||
        name === 'salesChartDisableClickUnavailable' ||
        name === 'unitListDisableClickUnavailable' ||
        name === 'hideTowersAndLevels' ||
        name === 'defaultFilter' ||
        name === 'siteplanSimpleMode' ||
        name === 'siteplanDelistedAsUnavailable'
      ) ? checked : !checked;
    }
    if ((name === 'salesChartSimpleMode' || name === 'siteplanSimpleMode') && !checked) {
      if (name === 'salesChartSimpleMode') {
        project.siteplanSettings.salesChartDelistedAsUnavailable = false;
        project.siteplanSettings.salesChartDisableClickUnavailable = false;
        project.siteplanSettings.unitListDisableClickUnavailable = false;
      }
      if (name === 'siteplanSimpleMode') {
        project.siteplanSettings.siteplanDelistedAsUnavailable = false;
      }
    }
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  async handleAddBankAccount(validations, { value }) {
    const { project, genericErrMsg } = this.state;
    const { store } = this.context;
    if (!project.projectBankAccount) project.projectBankAccount = [];
    if (validateForm(store, validations)) return;
    if (!this.hasUpdateAccess()) {
      // during project creation
      project.projectBankAccount.push(value);
      this.setState({ project });
      return;
    }
    await this.setLoading(true);
    try {
      const response = await serverRequestPost(
        `/projects/${project.id}/bank_accounts/`,
        store,
        this.props.token,
        value,
      );
      if (response.error) {
        this.handleError(store, response.message);
        return;
      }
      project.projectBankAccount.push(response.data);
      this.setState({ project });
      await this.setLoading(false);
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  async handleAddCurrency(validations, { value }) {
    const { project, genericErrMsg } = this.state;
    const { store } = this.context;
    if (!project.projectCurrency) project.projectCurrency = [];
    if (validateForm(store, validations)) return;
    await this.setLoading(true);
    if (!this.hasUpdateAccess()) {
      // during project creation
      project.projectCurrency.push(value);
      this.setState({ project });
      await this.setLoading(false);
      return;
    }
    try {
      const response = await serverRequestPost(
        `/projects/${project.id}/currency/`,
        store,
        this.props.token,
        value,
      );
      if (response.error) {
        this.handleError(store, response.message);
        return;
      }
      project.projectCurrency.push(response.data);
      this.setState({ project });
      await this.setLoading(false);
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  handleDeleteCurrency = async (e, { value }) => {
    await this.setLoading(true);
    const { project, genericErrMsg } = this.state;
    const { store } = this.context;
    const indexToBeDeleted = project.projectCurrency.findIndex(val => val.code === value.code);
    if (indexToBeDeleted === -1) {
      this.handleError(store, genericErrMsg);
      return;
    }

    if (!this.hasUpdateAccess()) {
      // during project creation
      project.projectCurrency.splice(indexToBeDeleted, 1);
      this.setState({ project });
      await this.setLoading(false);
      return;
    }

    try {
      const response = await serverRequestDelete(
        `/projects/${project.id}/currency/${value.id}/`,
        store,
        this.props.token,
      );
      if (response.error) {
        this.handleError(store, response.message);
        return;
      }
      project.projectCurrency.splice(indexToBeDeleted, 1);
      this.setState({ project });
      await this.setLoading(false);
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  async handleError(store, msg, errorObj, isBugsnag = false) {
    await this.setLoading(false);
    await store.dispatch(flashErrorMessage({ message: msg }));
    if (isBugsnag) Bugsnag.notifyException(errorObj);
  }
  async handleMakeDefaultCurrency(e, { value }) {
    const { project, genericErrMsg } = this.state;
    const { store } = this.context;
    const currentDefault = project.projectCurrency.find(val => val.isDefault === true);
    if (!currentDefault) {
      this.handleError(store, genericErrMsg);
      return;
    }
    if (!this.hasUpdateAccess()) {
      // during project creation

      const newData = project.projectCurrency.map((d) => {
        const currency = d;
        if (currency.code === currentDefault.code) currency.isDefault = false;
        if (currency.code === value.code) currency.isDefault = true;

        return currency;
      });
      project.projectCurrency = newData;
      this.setState({ project });
      await this.setLoading(false);
      return;
    }
    try {
      await this.setLoading(true);
      const promiseArr = [
        serverRequestPut(
          `/projects/${project.id}/currency/${currentDefault.id}/`,
          store,
          this.props.token,
          { isDefault: false },
        ),
        serverRequestPut(
          `/projects/${project.id}/currency/${value.id}/`,
          store,
          this.props.token,
          { isDefault: true },
        ),
      ];
      const promiseResultArray = await Promise.all(promiseArr);
      const noError = promiseResultArray.every(res => res.error === false);
      if (!noError) {
        this.handleError(store, genericErrMsg);
        return;
      }
      const newData = project.projectCurrency.map((d) => {
        const currency = d;
        if (currency.id === currentDefault.id) currency.isDefault = false;
        if (currency.id === value.id) currency.isDefault = true;

        return currency;
      });
      project.projectCurrency = newData;
      this.setLoading(false);
      this.setState({ project });
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  async handleSaveBankAccount(validations, { value }) {
    const { project, genericErrMsg } = this.state;
    const { store } = this.context;
    if (validateForm(store, validations)) return;

    const i = project.projectBankAccount.findIndex(val => (val.id === value.id));
    if (i === -1) {
      this.handleError(store, genericErrMsg);
      return;
    }

    // only allow update conversion rate
    project.projectBankAccount[i].isActive = value.isActive;

    if (!this.hasUpdateAccess()) {
      // during project creation
      this.setState({ project });
      return;
    }
    await this.setLoading(true);

    try {
      const response = await serverRequestPut(
        `/projects/${project.id}/bank_accounts/${value.id}/`,
        store,
        this.props.token,
        { isActive: value.isActive },
      );
      if (response.error) {
        await store.dispatch(flashErrorMessage({ message: response.message }));
        return;
      }
      this.setState({ project });
      await this.setLoading(false);
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  async handleSaveCurrency(validations, { value }) {
    const { project, genericErrMsg } = this.state;
    const { store } = this.context;
    if (validateForm(store, validations)) return;

    await this.setLoading(true);
    const i = project.projectCurrency.findIndex(val => (val.code === value.code && val.id === value.id));
    if (i === -1) {
      this.handleError(store, genericErrMsg);
      return;
    }

    // only allow update conversion rate
    project.projectCurrency[i].conversionRatePoint = value.conversionRatePoint;

    if (!this.hasUpdateAccess()) {
      // during project creation
      this.setState({ project });
      await this.setLoading(false);
      return;
    }

    try {
      const response = await serverRequestPut(
        `/projects/${project.id}/currency/${value.id}/`,
        store,
        this.props.token,
        { conversionRatePoint: value.conversionRatePoint },
      );
      if (response.error) {
        await store.dispatch(flashErrorMessage({ message: response.message }));
        return;
      }
      this.setState({ project });
      await this.setLoading(false);
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  async handleSaveTemplateToggle(id, value) {
    const { genericErrMsg, templatesToken } = this.state;
    const { t } = this.props;
    const { store } = this.context;
    await this.setLoading(true);

    try {
      const response = await store.dispatch(fetchM(`/templates/${id}/access/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': templatesToken,
        },
        body: JSON.stringify(value),
      }));
      if (response.error) {
        await store.dispatch(flashErrorMessage({ message: response.message }));
        return;
      }
      await store.dispatch(fetchTemplates('print', true));
      await this.setLoading(false);
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('{{name}} template access updated', { name: value.name, ns: TRANSLATION_FILES.translation }),
      }));
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  async handleUpdateHimsForBookings() {
    await this.setLoading(true);
    const { store } = this.context;
    const { project } = this.state;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${project.id}/bookings/hims/bulk/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('HIMS data successfully updated in all bookings', { ns: TRANSLATION_FILES.translation }) }));
    }
    await this.setLoading(false);
  }
  hasUpdateAccess = (props = this.props) => {
    const { pathname } = props.location;
    if (pathname.includes('/new/')) {
      return false;
    }
    return true;
  }

  buyerMarketplaceHasAccess() {
    const { companyApps } = this.props.auth;
    if (companyApps) {
      const buyerMarketplace = companyApps.find(ca => ca.appID === BUYER_MARKETPLACE);
      return buyerMarketplace && buyerMarketplace.hasAccess;
    }
    return false;
  }
  canAccessProjectReservationToken = () => {
    const { auth } = this.props;
    return auth.isSuperAdmin || auth.isAdminBasic || auth.isAdminCommunity
      || auth.isHeadquarters || auth.isDeveloperSalesAdmin || auth.isDeveloperSalesManager || auth.isDeveloperSupervisor;
  }
  ownershipTypes = [
    { text: 'Leasehold', value: 'leasehold' },
    { text: 'Freehold', value: 'freehold' },
  ]
  propertyCategoryTypes = [
    { text: 'Single Storey Terrace House', value: 'single_storey_terrace_house' },
    { text: '{{storey}} Storey Terrace House', value: '2_storey_terrace_house', storey: '2' },
    { text: '{{storey}} Storey Terrace House', value: '2_5_storey_terrace_house', storey: '2.5' },
    { text: '{{storey}} Storey Terrace House', value: '3_storey_terrace_house', storey: '3' },
    { text: '{{storey}} Storey Terrace House', value: '3_5_storey_terrace_house', storey: '3.5' },
    { text: 'Home/Land', value: 'home_land' },
    { text: 'Apartment', value: 'apartment' },
    { text: 'Flat', value: 'flat' },
    { text: 'Condominium', value: 'condominium' },
    { text: 'Service Residence', value: 'service_residence' },
    { text: 'Service Apartment', value: 'service_apartment' },
    { text: 'Terrace', value: 'terrace' },
    { text: 'Superlink Homes', value: 'superlink_homes' },
    { text: 'Townhouse', value: 'townhouse' },
    { text: 'Cluster House', value: 'cluster_house' },
    { text: 'Single Storey Cluster House', value: 'single_storey_cluster_house' },
    { text: '{{storey}} Storey Cluster House', value: '2_storey_cluster_house', storey: '2' },
    { text: '{{storey}} Storey Cluster House', value: '2_5_storey_cluster_house', storey: '2.5' },
    { text: '{{storey}} Storey Cluster House', value: '3_storey_cluster_house', storey: '3' },
    { text: 'Bungalow', value: 'bungalow' },
    { text: 'Single Storey Bungalow', value: 'single_storey_bungalow' },
    { text: '{{storey}} Storey Bungalow', value: '2_storey_bungalow', storey: '2' },
    { text: '{{storey}} Storey Bungalow', value: '2_5_storey_bungalow', storey: '2.5' },
    { text: '{{storey}} Storey Bungalow', value: '3_storey_bungalow', storey: '3' },
    { text: 'SemiD House', value: 'semi_d' },
    { text: 'Single Storey SemiD House', value: 'single_storey_semi_d' },
    { text: '{{storey}} Storey SemiD House', value: '2_storey_semi_d', storey: '2' },
    { text: '{{storey}} Storey SemiD House', value: '2_5_storey_semi_d', storey: '2.5' },
    { text: '{{storey}} Storey SemiD House', value: '3_storey_semi_d', storey: '3' },
    { text: 'Villa', value: 'villa' },
    { text: 'Retail Office', value: 'retail_office' },
    { text: 'Retail Space', value: 'retail_space' },
    { text: 'Shop', value: 'shop' },
    { text: 'Shop Office', value: 'shop_office' },
    { text: '{{storey}} Storey Shop Office', value: '2_storey_shop_office', storey: '2' },
    { text: '{{storey}} Storey Shop Office', value: '3_storey_shop_office', storey: '3' },
    { text: 'Office', value: 'office' },
    { text: 'Office Suites', value: 'office_suites' },
    { text: 'Sofo', value: 'sofo' },
    { text: 'Soho', value: 'soho' },
    { text: 'Sovo', value: 'sovo' },
    { text: 'Designer Suites', value: 'designer_suites' },
    { text: 'Business Centre', value: 'business_centre' },
    { text: 'Hotel Suite', value: 'hotel_suite' },
    { text: 'Factory', value: 'factory' },
    { text: 'SemiD Factory', value: 'semi_d_factory' },
    { text: 'Warehouse', value: 'warehouse' },
    { text: 'Detached Factory', value: 'detached_factory' },
    { text: 'Light Industrial', value: 'light_industrial' },
    { text: 'Link Factory', value: 'link_factory' },
    { text: 'Bungalow Land', value: 'bungalow_land' },
    { text: 'Strata Villa', value: 'strata_villa' },
    { text: 'Commercial Suites', value: 'commercial_suites' },
  ]
  areaUnits = [
    { text: 'Square Feet (sqft)', value: 'square_feet' },
    { text: 'Square Metres (sqm)', value: 'square_metres' },
  ]
  overlayModes = [
    { text: 'Status Text', value: 'text' },
    { text: 'Color', value: 'color' },
  ]
  buildTabs = (props = this.props) => [
    {
      name: 'info',
      value: 'info',
      text: 'Info',
      fields: ['name', 'shortName', 'phone', 'foreignPurchaseThreshold'],
    },
    {
      name: 'location',
      value: 'location',
      text: 'Location',
      fields: props.addressSettings.data.filter(as => as.enabled && as.required),
    },
    {
      name: 'specifications',
      value: 'specifications',
      text: 'Specifications',
      fields: [],
    },
    {
      name: 'overview',
      value: 'overview',
      text: 'Description',
      fields: [],
    },
    {
      name: 'company_info',
      value: 'company_info',
      text: 'Registered Company Info',
      fields: [],
    },
    {
      name: 'setup',
      value: 'setup',
      text: 'Setup',
      fields: [],
    },
    {
      name: 'booking_setup',
      value: 'booking_setup',
      text: 'Booking Setup',
      fields: [],
    },
    props.appConfig && props.appConfig.data
      && props.appConfig.data.himsIsEnabled
      && (props.auth.isSuperAdmin || props.auth.isAdminBasic)
      && {
        name: 'hims_setup',
        value: 'hims_setup',
        text: 'HIMS Setup',
        fields: ['himsStrataIsEnabled'],
      },
    this.hasCompanyQuotationEnabled(props) && config.get('developerURL') && props.auth.company.service_company_id && {
      name: 'quotation',
      value: 'quotation',
      text: 'Quotation',
      fields: [],
      redirectTo: `${config.get('developerURL')}/c/${props.auth.company.service_company_id}/projects/${props.params.id}/edit?tab=quotation`,
    },
    {
      name: 'docx_templater_setting',
      value: 'docx_templater_setting',
      text: 'Form Template',
      fields: [],
    },
    !isPRS && config.get('developerURL') && props.auth.company.service_company_id && {
      name: 'auto_release',
      value: 'auto_release',
      text: 'Auto Release',
      fields: [],
      redirectTo: `${config.get('developerURL')}/c/${props.auth.company.service_company_id}/projects/${props.params.id}/edit?tab=auto_release`,
    },
    config.get('developerURL') && props.auth && props.auth.company.service_company_id && isForeignCompany(props.auth.company) && {
      name: 'payment_schedule',
      value: 'payment_schedule',
      text: 'Payment Schedules',
      fields: [],
      redirectTo: `${config.get('developerURL')}/c/${props.auth.company.service_company_id}/projects/${props.params.id}/edit?tab=payment_schedule`,
    },
    config.get('developerURL') && props.auth.company.service_company_id && {
      name: 'additional_fees',
      value: 'additional_fees',
      text: 'Additional Fees',
      fields: [],
      redirectTo: `${config.get('developerURL')}/c/${props.auth.company.service_company_id}/projects/${props.params.id}/edit?tab=additional_fees`,
    },
    {
      name: 'payment_setup',
      value: 'payment_setup',
      text: 'Payment Setup',
      fields: [],
    },
    {
      name: 'sales_chart_setup',
      value: 'sales_chart_setup',
      text: 'Sales Chart Setup',
      fields: [],
    },
    {
      name: 'marketplace',
      value: 'marketplace',
      text: 'Marketplace',
    },
    this.hasUpdateAccess(props) && {
      name: 'booking_fields',
      value: 'booking_fields',
      text: 'Booking Fields',
      fields: [],
    },
    // (this.hasUpdateAccess(props) && props.auth.isAdminBasic) && {
    //   name: 'tier_pricing',
    //   value: 'tier_pricing',
    //   text: 'Discount Package (OLD)',
    //   fields: [],
    // },
    {
      name: 'access',
      value: 'access',
      text: 'Access',
      fields: [],
    },
    this.hasUpdateAccess(props) && {
      name: 'letter_settings',
      value: 'letter_settings',
      text: 'Reminder Letter Settings',
      fields: [],
    },
    props.auth && !isForeignCompany(props.auth.company) && {
      name: 'currency_settings',
      value: 'currency_settings',
      text: 'Currency Settings',
      fields: [],
    },
    this.hasUpdateAccess(props) && {
      name: 'options',
      value: 'api_options',
      text: 'API Options',
      fields: [],
    },
    this.hasUpdateAccess(props) && this.canAccessProjectReservationToken() && {
      name: 'reservation_token_settings',
      value: 'reservation_token_settings',
      text: 'Reservation Token Settings',
      fields: [],
    },
  ];
  salesChartRefreshTimes = [
    { text: '15', value: 15 },
    { text: '20', value: 20 },
    { text: '30', value: 30 },
    { text: '40', value: 40 },
    { text: '50', value: 50 },
    { text: '60', value: 60 },
    { text: '120', value: 120 },
  ]
  bapMinutesOptions = [
    { key: 'o30', text: '30 (30 Minutes)', value: '30' },
    { key: 'o60', text: '60 (1 Hour)', value: '60' },
    { key: 'o120', text: '120 (2 Hours)', value: '120' },
    { key: 'o180', text: '180 (3 Hours)', value: '180' },
    { key: 'o360', text: '360 (6 Hours)', value: '360' },
    { key: 'o720', text: '720 (12 Hours)', value: '720' },
    { key: 'o1440', text: '1440 (1 Day)', value: '1440' },
  ]
  handleRedirect = (url) => {
    const { store } = this.context;
    if (url.includes(config.get('developerURL'))) {
      window.location.href = url;
    } else {
      store.dispatch(replace(url));
    }
  }
  handleChangeTab = (e, { name, value }, redirectTo) => {
    if (redirectTo && redirectTo !== '') {
      this.handleRedirect(redirectTo);
      return;
    }
    const currentTab = name || value;
    this.setState({ currentTab }, () => {
      const { hash, pathname } = this.props.location;
      if (hash !== `#${currentTab}`) {
        const { store } = this.context;
        store.dispatch(replace(`${pathname}#${currentTab}`));
      }
    });
  }
  checkActiveTab = name => (this.isActiveTab(name) ? '' : 'hidden');
  isActiveTab = name => this.state.currentTab === name;
  handleBranchClear = () => {
    const { project } = this.state;
    project.maOwnerCompanyBranchShortName = '';
    project.maOwnerCompanyBranchID = 0;
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handleBranchSelect = (value) => {
    const { project } = this.state;
    project.maOwnerCompanyBranchShortName = value.title;
    project.maOwnerCompanyBranchID = value.key;
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  defaultBookingStatutes = [
    { text: 'Reserved', value: 'reserved', name: 'reserved' },
    { text: 'Booked', value: 'booked', name: 'booked' },
  ]
  handlePreviewSaleschart = (e) => {
    e.preventDefault();
    const { project } = this.state;
    if (project.id) {
      const chartLanguage = normalizeLanguage(this.props.i18n.language)
        || normalizeLanguage(this.props.auth.language) || 'en';
      const chartOrigin = config.get('salesChartURL');
      const winObj = window.open(
        `${chartOrigin}/?projectID=${project.id}&lang=${encodeURIComponent(chartLanguage)}`,
        '_blank',
      );
      winObj.opener = null;
    }
  }
  handleCheckBeforeClose = (type = 'siteplan') => {
    const { t } = this.props;
    if (this.uploadForm[type] && this.uploadForm[type].state.uploads.length > 0) {
      const callback = () => {
        if (this.uploadModal[type]) {
          this.uploadModal[type].close();
        }
      };
      const { store } = this.context;
      store.dispatch(promptChangesMessage({ message: t(UPLOAD_PICTURE_PROMPT, { ns: TRANSLATION_FILES.translation }), callback }));
      return true;
    }
    return false;
  }
  hasSiteplan(checkType) {
    const { siteplanHasSvg, siteplanHasImage } = this.state;
    if (checkType) {
      if (checkType === 'svg') {
        return siteplanHasSvg;
      }
      return siteplanHasImage;
    }
    return siteplanHasSvg && siteplanHasImage;
  }
  handlePricingTierChange = (data) => {
    const { project } = this.state;
    project.projectPricings = data;
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handlePricingTierDelete = (id) => {
    this.deletePricingTier(id);
  }
  handlePricingSave = (data) => {
    const { project } = this.state;
    project.projectPricings = data;
    this.setState({ project }, () => {
      this.handleCheckChanges();
      this.handleSubmit();
    });
  }
  handleBankerFormChange = (bankerFormState) => {
    this.handleSubmitBankerFormTemplate(bankerFormState);
  }
  handleOnChangeCustomFieldData = (d) => {
    const { project } = this.state;
    project.projectBookingCustomFields = d;
    this.setState({ project }, () => {
      this.handleCheckChanges();
    });
  }
  handleImportPricingClick = (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { project } = this.state;
    store.dispatch(push(`/projects/${project.id}/units/import_pricings/`));
  }
  handleChangeBAPWindow = (value) => {
    const { project } = this.state;
    project.bapWindowMinutes = value;
    this.setState({ project }, () => this.handleCheckChanges());
  }
  handleChangeBAPCooldown = (value) => {
    const { project } = this.state;
    project.bapCooldownMinutes = value;
    this.setState({ project }, () => this.handleCheckChanges());
  }
  getCompanyCurrencyOptions() {
    const { companyCurrency = [] } = this.props.auth.company;
    return companyCurrency.map(c => ({
      text: c.name,
      value: c.code,
    }));
  }
  getCompanyDefaultCurrency() {
    const { companyCurrency = [] } = this.props.auth.company;
    const currency = companyCurrency.find(c => c.isDefault) || {};
    return currency.code || '';
  }
  handleOnClose = () => {
    this.setState({ openTncModal: false });
  }
  showTnC = (e) => {
    e.preventDefault();
    this.setState({ openTncModal: true });
  }

  getFinanceSourceLabel = (type) => {
    const { financeSources } = this.props;
    const sources = financeSources.data;
    const idx = sources.findIndex(s => s.id === type);
    if (idx > -1) {
      return sources[idx].label;
    }
    return 'Others';
  }
  handleOnHimsSettingsChange = (data) => {
    const { project, tabs } = this.state;
    project.projectHimsSettings = data;

    const tabIdx = tabs.findIndex(t => t.name === 'hims_setup' || t.value === 'hims_setup');
    if (tabIdx >= 0) {
      tabs[tabIdx].fields = ['himsStrataIsEnabled'];
      data.forEach((d, idx) => {
        tabs[tabIdx].fields.push(
          `himsDeveloperCode_${idx}`,
          `himsDeveloperName_${idx}`,
          `himsDeveloperLicense_${idx}`,
          `himsDevelopmentCode_${idx}`,
          `himsDevelopmentName_${idx}`,
        );
      });
    }

    this.setState({ project, tabs }, () => {
      this.handleCheckChanges();
    });
  }
  handleReservationTokenSettingChange = (_e, { name, value }) => {
    const { projectReservationTokenSetting } = this.state;
    this.setState({ projectReservationTokenSetting: { ...projectReservationTokenSetting, [name]: value } }, () => {
      this.handleCheckChanges();
    });
  }

  saveReservationTokenSettings = async (suppressSuccess = false) => {
    const { store } = this.context;
    const { t } = this.props;
    const { project, projectReservationTokenSetting, token } = this.state;
    try {
      const rtValidation = this.rtValidation;
      const validations = await AppForm.validate(rtValidation, {
        rtPriceMinor: projectReservationTokenSetting.priceMinor,
        rtValidityDurationDays: projectReservationTokenSetting.validityDurationDays,
        rtLimitPerOpportunity: projectReservationTokenSetting.limitPerOpportunity,
      });
      if (validations.some(v => !v.isValid)) {
        store.dispatch(flashErrorMessage({ message: t('Please fix the errors in Reservation Token Settings before saving') }));
        return false;
      }
      const payload = {
        ...projectReservationTokenSetting,
        priceMinor: Math.max(1, parseInt(projectReservationTokenSetting.priceMinor, 10) || 1),
        validityDurationDays: Math.max(1, parseInt(projectReservationTokenSetting.validityDurationDays, 10) || 1),
        limitPerOpportunity: Math.max(1, parseInt(projectReservationTokenSetting.limitPerOpportunity, 10) || 1),
      };
      const res = await store.dispatch(fetchM(
        `${config.get('bookApiURL')}/projects/${project.id}/reservation_token_settings/`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json', 'X-Csrf-Token': token },
          body: JSON.stringify(payload),
        },
      ));
      if (res.ok) {
        const data = await res.json();
        this.setState({
          projectReservationTokenSetting: data,
          oriProjectReservationTokenSetting: clone(data),
        });
        if (!suppressSuccess) {
          store.dispatch(flashSuccessMessage({ message: t('Reservation token settings saved successfully') }));
        }
      } else {
        const msg = await res.text();
        store.dispatch(flashErrorMessage({ message: msg }));
      }
      return true;
    } catch (e) {
      store.dispatch(flashErrorMessage({ message: e.message }));
      return false;
    }
  }

  renderFinanceSourceItem = (fsID) => {
    const { project } = this.state;
    const { t } = this.props;
    const opt = getSourceOfFinanceValue(fsID);
    const sourcesOnByDefault = !isForeignCompany(this.props.auth.company) && opt === 'referred_banker';
    const financeSourceLabel = this.getFinanceSourceLabel(fsID);
    return (
      <Form.Group key={`fsr_${fsID}`}>
        <Form.Field label={`${t(financeSourceLabel, { ns: TRANSLATION_FILES.constants, defaultValue: financeSourceLabel })} ${sourcesOnByDefault ? `(${t('ON by default')})` : ''}`} width={11} />
        <Form.Field width={5}>
          <Form.Checkbox
            toggle
            label={t(project.sourceOfFinanceOptions && project.sourceOfFinanceOptions.length > 0 && project.sourceOfFinanceOptions.some(o => o === opt) ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
            name={opt}
            checked={project.sourceOfFinanceOptions && project.sourceOfFinanceOptions.length > 0 && project.sourceOfFinanceOptions.includes(opt)}
            onChange={this.handleFinanceSourcesCheckboxChange}
            disabled={sourcesOnByDefault}
          />
        </Form.Field>
      </Form.Group>
    );
  }

  render() {
    const {
      project,
      oriProject,
      // bForms,
      // bobForms,
      formAccessibilitiesTemplateIDs,
      pTemplates,
      printTemplates,
      printLoanReminderTemplates,
      printSPAReminderTemplates,
      printTerminationTemplates,
      salesChartTemplates,
      salesChartTypes,
      systemData,
      isVisible,
      projectReservationTokenSetting,
    } = this.state;
    const { t } = this.props;
    // const bobTypes = [
    //   ...bobForms,
    // ];
    const printTypes = [
      { text: t('None', { ns: TRANSLATION_FILES.constants }), value: 'none' },
      ...printTemplates,
    ];
    let docxPrintIsSelected = false;
    if (project.printType !== 'none' && !project.printType.startsWith('db/templates/bookings/')) {
      docxPrintIsSelected = true;
    }
    const printLoanReminderTypes = [
      { text: t('None', { ns: TRANSLATION_FILES.constants }), value: 'none' },
      ...printLoanReminderTemplates,
    ];
    const printSPAReminderTypes = [
      { text: t('None', { ns: TRANSLATION_FILES.constants }), value: 'none' },
      ...printSPAReminderTemplates,
    ];
    const printTerminationTypes = [
      { text: t('None', { ns: TRANSLATION_FILES.constants }), value: 'none' },
      ...printTerminationTemplates,
    ];
    const salesChartTemplateTypes = [
      { text: t('Default'), value: 'default' },
      ...salesChartTemplates,
    ];
    const exportItems = [
      {
        text: 'CSV',
        href: `${config.get('bookApiURL')}/projects/${project.id}/siteplans/units/?fileType=csv`,
      },
      {
        text: 'Excel',
        href: `${config.get('bookApiURL')}/projects/${project.id}/siteplans/units/?fileType=excel`,
      },
    ];
    const customerBookingSuccessEmailTypes = [
      { text: t('Default'), value: 'email/booking_confirmed_customer.html' },
      ...this.state.bookingCustomerSuccessEmailTemplates,
    ];
    // const billingDateSources = [
    //   { text: translateModels(t, 'spaSigningDate', 'booking'), value: 'spa_signing_date' },
    //   { text: translateModels(t, 'spaStampingDate', 'booking'), value: 'spa_stamping_date' },
    // ];

    const regions = systemData.regions ? systemData.regions : [];
    const regionOptions = regions.map(x => ({
      value: x,
      text: x,
    }));
    const townships = systemData.townships ? systemData.townships : [];
    const townshipOptions = townships.map(x => ({
      value: x,
      text: x,
    }));
    const { pathname } = this.props.location;
    const isCUExternalSelected = project.cuRoleAccesses && project.cuRoleAccesses.includes(CU_EXTERNAL_STAFF_ACCESS);

    const { addressSettings, financeSources } = this.props;
    const enabledFinanceSources = financeSources.data.filter(fs => fs.isEnabled);
    const enabledAddressSettings = addressSettings.data.filter(as => as.enabled);
    // TODO refactor all code related to country checking
    const isMalaysia = project.country.toUpperCase() === 'MY';
    const isVietnam = project.country.toUpperCase() === 'VN';
    // CPI-974 item 18: a Vietnam-only control, gated on the company country through the helper.
    const isVietnamCompany = isCountryVietnam(this.props.auth && this.props.auth.company && this.props.auth.company.countryCode);
    // CPI-1464: the two cross-project / delisted change-unit boxes are an MHub-admin-only sight in Vietnam.
    const hideChangeUnitOptions = vnHidesChangeUnitOptions(this.props.auth);
    const eventTime = project.mpBuyerEventLaunchAt && (
      isVietnamCompany ? moment(project.mpBuyerEventLaunchAt).local() : moment(project.mpBuyerEventLaunchAt)
    );
    // Hidden: no place to enter a payment on a Vietnamese Sales Overview since CPI-974; re-enable when the payment section returns.
    // const paymentApprovedRequiredStatusOptions = BOOKING_STATUSES
    //   .filter(s => s.value === 'booked' || s.value === 'sold_spa_signed')
    //   .map(s => ({ value: s.value, text: t(s.text, { ns: TRANSLATION_FILES.constants }) }));
    const inputs = enabledAddressSettings.map((as, idx) => {
      const key = _.camelCase(as.columnName);
      let addressLabel = as.label.toLowerCase();
      let isRequired = as.required;
      const validations = [{
        validate: stringLength,
        option: {
          max: 256,
        },
      }];

      // for Skyworld Vietnam, we update the label name for state/city/postcode to province/ward/postalCode
      // and set the required flag to false
      if (isVietnam && addressLabel === 'state') {
        addressLabel = 'cityOrProvince';
        isRequired = false;
      } else if (isVietnam && addressLabel === 'city') {
        addressLabel = 'ward';
        isRequired = false;
      } else if (isVietnam && addressLabel === 'postcode') {
        addressLabel = 'postalCode';
        isRequired = false;
      }

      if (isRequired) {
        validations.push(required);
      }

      const label = `${translateModels(t, addressLabel, 'project')}${isRequired ? '*' : ''}`;

      if (isMalaysia && as.label.toLowerCase() === 'state') {
        return (
          <AppForm.Validate
            key={idx}
            validation={as.required ? [required] : null}
            ref={this.validation[key]}
            onChange={this.handleInputChange}
            validateLabel={as.label.toLowerCase() === 'state' ? translateModels(t, 'state', 'project') : as.label}
          >
            <Form.Select
              name={key}
              fluid
              options={STATES}
              placeholder={t('Select {{title}}', { title: label.toLowerCase() })}
              label={label}
              search
              selectOnBlur={false}
              value={project[key]}
            />
          </AppForm.Validate>
        );
      }

      return (
        <AppForm.Input
          key={idx}
          autoComplete="off"
          name={key}
          onChange={this.handleInputChange}
          placeholder={label}
          label={label}
          ref={this.validation[key]}
          validation={validations}
          value={project[key]}
          validateLabel={as.label}
        />
      );
    });

    inputs.push((
      <Form.Select
        key="inputs_region"
        label={translateModels(t, 'region', 'project')}
        name="region"
        placeholder={t('{{title}}', { title: translateModels(t, 'region', 'project') })}
        search
        fluid
        onChange={this.handleInputChange}
        value={project.region}
        options={regionOptions}
        noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
      />
    ), (
      <Select
        key="inputs_country"
        validation={[required]}
        ref={this.validation.country}
        onChange={(e, data) => {
          // Reset state input field
          const as = enabledAddressSettings.find(a => a.label.toLowerCase() === 'state');
          if (as) {
            const key = _.camelCase(as.columnName);
            if (project[key]) {
              project[key] = '';
              this.setState({ project });
            }
          }
          this.handleInputChange(e, data);
        }}
        validateLabel={translateModels(t, 'country', 'project')}
        autoComplete="off"
        label={translateModels(t, 'country', 'project')}
        name="country"
        options={SELECT_COUNTRIES}
        placeholder={t('Select {{title}}', { title: translateModels(t, 'country', 'project') })}
        selectOnBlur={false}
        value={project.country}
      />
    ), ...(!isVietnam ? [(
      <Form.Select
        key="inputs_township"
        label={translateModels(t, 'township', 'project')}
        name="township"
        placeholder={t('Select {{title}}', { title: translateModels(t, 'township', 'project') })}
        search
        fluid
        onChange={this.handleInputChange}
        value={project.township}
        options={townshipOptions}
      />
    )] : []),
  );
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns="equal" stackable doubling>
          <Dimmer style={{ zIndex: 20 }} active={this.props.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={16} computer={4}>
              <Menu
                fluid
                widths={!this.state.menuIsTab ? 1 : null}
                tabular={this.state.menuIsTab}
                vertical={this.state.menuIsVertical}
              >
                {
                  !this.state.menuIsTab ?
                    <Dropdown
                      item
                      selectOnBlur={false}
                      options={this.state.tabs.filter(tb => tb).map((tb, k) => {
                        const tab = {
                          key: k,
                          text: t(tb.text),
                          name: tb.name,
                          value: tb.value,
                          redirectTo: tb.redirectTo,
                          label: this.state.errMessages.some(e => tb.fields.some(f => e.key === f)) ?
                          {
                            color: 'red',
                            content: '!',
                          } : null,
                        };
                        return tab;
                      })}
                      onChange={(e, props) => {
                        const option = _.find(props.options, opt => opt.name === props.value);
                        const url = option && option.redirectTo;
                        this.handleChangeTab(e, props, url);
                      }}
                      value={this.state.currentTab}
                      disabled={this.state.loading}
                    />
                    : this.state.tabs.map((tab, key) => {
                      if (tab) {
                        if (!systemData.docxTemplaterIsEnabled && tab.name === 'docx_templater_setting') {
                          return null;
                        }
                        return (
                          <Menu.Item
                            key={key}
                            name={tab.name}
                            onClick={(e, props) => this.handleChangeTab(e, props, tab.redirectTo)}
                            active={this.state.currentTab === tab.name}
                          >
                            {t(tab.text)}
                            {
                              this.state.errMessages.some(e => tab.fields
                                && tab.fields.some(f => e.key === f)) ?
                                  <Label color="red" floating={!this.state.menuIsVertical} content="!" />
                                : null
                            }
                          </Menu.Item>
                        );
                      }
                      return null;
                    })
                }
                { this.state.menuIsTab ?
                  <Menu.Item key="switch" name="switch">
                    <div className="switch-button">
                      <Button
                        basic
                        as="a"
                        href={`${config.get('developerURL')}/c/${this.props.auth.company.service_company_id}${pathname}`}
                        content={t('Switch to new layout')}
                      />
                    </div>
                  </Menu.Item>
                  : null
                }
              </Menu>
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('info')}>
              <Select
                validation={[required]}
                ref={this.validation.statusID}
                onChange={this.handleInputChange}
                label={translateModels(t, 'statusID', 'project')}
                name="statusID"
                value={project.statusID}
                options={PROJECT_STATUSES.map(ps => ({
                  ...ps,
                  text: t(ps.text, { ns: TRANSLATION_FILES.constants }),
                }))}
              />
              <AppForm.Input
                label={translateModels(t, 'name', 'project')}
                name="name"
                value={project.name}
                onChange={this.handleInputChange}
                ref={this.validation.name}
                validation={[required]}
              />
              <AppForm.Input
                label={translateModels(t, 'shortName', 'project')}
                name="shortName"
                value={project.shortName}
                onChange={this.handleInputChange}
                ref={this.validation.shortName}
                validation={[required]}
              />
              <AppForm.Input
                label={translateModels(t, 'referenceCode', 'project')}
                name="referenceCode"
                value={project.referenceCode}
                onChange={this.handleInputChange}
                ref={this.validation.referenceCode}
              />
              <Form.Group widths="equal">
                <Form.Select
                  label={translateModels(t, 'phonePrefix', 'project')}
                  name="phonePrefix"
                  value={project.phonePrefix}
                  text={project.phonePrefix === '' ? t('Other', { ns: TRANSLATION_FILES.constants }) : null}
                  onChange={this.handleInputChange}
                  search
                  options={INTL_CALL_CODES}
                  noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                />
                <PhoneInput
                  label={translateModels(t, 'phone', 'project')}
                  type="tel"
                  name="phone"
                  value={project.phone}
                  onChange={this.handleInputChange}
                  ref={this.validation.phone}
                  prefix={project.phonePrefix}
                  placeholder={project.phonePrefix === '60' ? `${translateModels(t, 'phone', 'project')} (e.g. 378317749)` : translateModels(t, 'phone', 'project')}
                  validation={[required, phone]}
                />
                <Form.Input
                  label={translateModels(t, 'published_at', 'project')}
                  type="datetime-local"
                  name="publishedAt"
                  value={project.publishedAt ? project.publishedAt.substring(0, 16) : ''}
                  onChange={(e, { value }) => {
                    project.publishedAt = value ? moment(value).format() : null;
                    this.setState({ project }, () => {
                      this.handleCheckChanges();
                    });
                  }}
                />
              </Form.Group>
              <Divider horizontal>{t('Type')}</Divider>
              <Form.Group widths={2}>
                <Select
                  validation={[required]}
                  ref={this.validation.ownershipType}
                  onChange={this.handleInputChange}
                  label={translateModels(t, 'ownershipType', 'project')}
                  name="ownershipType"
                  value={project.ownershipType}
                  options={this.ownershipTypes.map(ot => ({
                    ...ot,
                    text: t(ot.text, { ns: TRANSLATION_FILES.constants }),
                  }))}
                />
                <Select
                  validation={[required]}
                  ref={this.validation.propertyCategoryID}
                  onChange={this.handleInputChange}
                  label={translateModels(t, 'propertyCategoryID', 'project')}
                  name="propertyCategoryID"
                  value={project.propertyCategoryID}
                  options={this.propertyCategoryTypes.map(pct => ({
                    ...pct,
                    text: t(pct.text, { ns: TRANSLATION_FILES.constants, storey: pct.storey }),
                  }))}
                />
                <Form.Group grouped>
                  <Form.Field label={t('Property Type')} />
                  <Form.Group grouped>
                    <Form.Checkbox
                      label={translateModels(t, 'isCommercial', 'project')}
                      name="isCommercial"
                      checked={project.isCommercial}
                      onChange={this.handleCheckBoxChange}
                    />
                    <Form.Checkbox
                      label={translateModels(t, 'isIndustrial', 'project')}
                      name="isIndustrial"
                      checked={project.isIndustrial}
                      onChange={this.handleCheckBoxChange}
                    />
                    <Form.Checkbox
                      label={translateModels(t, 'isResidential', 'project')}
                      name="isResidential"
                      checked={project.isResidential}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Form.Group>
                </Form.Group>
              </Form.Group>
              {/* Keep text input: AppForm's number validation converts an empty input to 0. */}
              { showsForeignPurchaseThreshold(this.props.auth) && (
                <React.Fragment>
                  <Divider horizontal>{t('Foreign Purchase Control')}</Divider>
                  <Form.Group widths={3}>
                    <Form.Field>
                      <AppForm.Input
                        label={translateModels(t, 'foreignPurchaseThreshold', 'project')}
                        name="foreignPurchaseThreshold"
                        value={project.foreignPurchaseThreshold}
                        onChange={this.handleInputChange}
                        ref={this.validation.foreignPurchaseThreshold}
                        validation={[validateForeignPurchaseThreshold]}
                        message={t('Enter a value from 0–100. Only numeric input is accepted.')}
                        type="text"
                        icon={<Icon name="percent" fitted color="grey" />}
                      />
                      <i style={{ color: 'grey' }}>
                        {t('Enter a value from 0–100. Only numeric input is accepted.')}
                      </i>
                    </Form.Field>
                  </Form.Group>
                </React.Fragment>
              )}
              <Divider horizontal>
                <Form.Checkbox
                  label={translateModels(t, 'manualPrice', 'project')}
                  name="manualPrice"
                  checked={project.manualPrice}
                  onChange={this.handleCheckBoxChange}
                />
              </Divider>
              <Form.Group widths="equal">
                <AppForm.Input
                  label={t('Minimum')}
                  type="text"
                  name="minPrice"
                  value={this.formatVND(this.state.project.minPrice)}
                  onChange={this.handleInputChange}
                  ref={this.validation.minPrice}
                  disabled={!project.manualPrice}
                />
                <AppForm.Input
                  label={t('Maximum')}
                  type="text"
                  name="maxPrice"
                  value={this.formatVND(this.state.project.maxPrice)}
                  onChange={this.handleInputChange}
                  ref={this.validation.maxPrice}
                  disabled={!project.manualPrice}
                />
              </Form.Group>
              <Divider horizontal>
                <Form.Checkbox
                  label={translateModels(t, 'manualSize', 'project')}
                  name="manualSize"
                  checked={project.manualSize}
                  onChange={this.handleCheckBoxChange}
                />
              </Divider>
              <Form.Group widths="equal">
                <AppForm.Input
                  label={t('Minimum')}
                  type="number"
                  name="minSize"
                  value={project.minSize}
                  onChange={this.handleInputChange}
                  ref={this.validation.minSize}
                  disabled={!project.manualSize}
                  step="0.0001"
                />
                <AppForm.Input
                  label={t('Maximum')}
                  type="number"
                  name="maxSize"
                  value={project.maxSize}
                  onChange={this.handleInputChange}
                  ref={this.validation.maxSize}
                  disabled={!project.manualSize}
                  step="0.0001"
                />
              </Form.Group>
              <Select
                validation={[required]}
                ref={this.validation.sizeSuffix}
                onChange={this.handleInputChange}
                label={translateModels(t, 'sizeSuffix', 'project')}
                name="sizeSuffix"
                value={project.sizeSuffix}
                options={this.areaUnits.map(an => ({
                  ...an,
                  text: isVietnamCompany && an.value === 'square_metres'
                    ? t('Square Metres (m²)', { ns: TRANSLATION_FILES.constants })
                    : t(an.text, { ns: TRANSLATION_FILES.constants }),
                }))}
              />
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('location')}>
              <Grid style={{ height: '100%' }} verticalAlign="top">
                <Grid.Row>
                  <Grid.Column>
                    {
                      // group 2 inputs into one Form.Group
                      // https://stackoverflow.com/questions/49491452/map-an-array-by-every-two-elements
                      _.chunk(inputs, 2).map((p, idx) => (
                        <Form.Group widths="equal" key={`group_${idx}`}>
                          {p}
                        </Form.Group>
                      ))
                    }
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('specifications')}>
              <SpecificationTable
                type="projects"
                editable
                isEditing
                hideButton
                data={project.specifications}
                onChange={this.handleSpecificationsChange}
                loading={this.state.loading}
              />
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('overview')}>
              <Grid style={{ height: '100%' }} verticalAlign="top">
                <Grid.Row>
                  <Grid.Column>
                    <Form.Group widths="equal">
                      <Form.Input
                        label={translateModels(t, 'overviewTitle', 'project')}
                        name="overviewTitle"
                        fluid
                        value={project.overviewTitle}
                        onChange={this.handleInputChange}
                      />
                      <Form.Input
                        label={translateModels(t, 'overviewSubTitle', 'project')}
                        name="overviewSubTitle"
                        fluid
                        value={project.overviewSubTitle}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>
                    <Segment padded style={{ border: '1px solid rgba(34,36,38,0.15)', borderRadius: 8, marginBottom: '1rem' }}>
                      <Form.Field>
                        <label>
                          <Icon name="external alternate" /> {translateModels(t, 'externalLink', 'project')}
                        </label>
                        <Form.Group widths="equal">
                          <Form.Input
                            width={6}
                            label={translateModels(t, 'buttonName', 'project')}
                            name="overviewExtLinkTitle"
                            value={project.overviewExtLinkTitle || ''}
                            onChange={this.handleInputChange}
                          />
                          <Form.Input
                            width={10}
                            label={translateModels(t, 'linkUrl', 'project')}
                            name="overviewExtLinkUrl"
                            value={project.overviewExtLinkUrl || ''}
                            onChange={this.handleInputChange}
                          />
                        </Form.Group>
                      </Form.Field>
                    </Segment>
                    <Form.TextArea
                      label={translateModels(t, 'overview', 'project')}
                      name="overview"
                      value={project.overview}
                      onChange={this.handleInputChange}
                    />
                    <Divider horizontal>{t('Preview', { ns: TRANSLATION_FILES.translation })}</Divider>
                    {
                      project.overviewTitle || project.overviewSubTitle ?
                        <Header
                          as="h2"
                          content={project.overviewTitle || project.overviewSubTitle}
                          subheader={project.overviewTitle ? project.overviewSubTitle : null}
                        /> : null
                    }
                    {
                      project.overviewExtLinkUrl ? (
                        <Button
                          href={sanitizeUrl(project.overviewExtLinkUrl)}
                          target="_blank"
                          rel="noopener noreferrer"
                          primary
                          compact
                          style={{ marginBottom: '0.5rem' }}
                        >
                          <Icon name="external alternate" />
                          {project.overviewExtLinkTitle}
                        </Button>
                      ) : null
                    }
                    {
                      project.overview ? <MarkdownText content={project.overview} /> : null
                    }
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('company_info')}>
              <Grid style={{ height: '100%' }}>
                <Grid.Row>
                  <Grid.Column>
                    <Divider horizontal>{t('Company Info')}</Divider>
                    <Form.Group widths="equal">
                      <Form.Input
                        label={t('Name')}
                        name="companyName"
                        fluid
                        value={project.companyName}
                        onChange={this.handleInputChange}
                      />
                      <Form.Input
                        label={t('Registration No.')}
                        name="companyRegistrationNo"
                        fluid
                        value={project.companyRegistrationNo}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>
                    <Form.TextArea
                      label={t('Address')}
                      name="companyAddress"
                      value={project.companyAddress}
                      onChange={this.handleInputChange}
                    />
                    <Form.Group widths="equal">
                      <Form.Input
                        label={t('Contact No. {{count}}', { count: 1 })}
                        name="companyContactNo1"
                        fluid
                        value={project.companyContactNo1}
                        onChange={this.handleInputChange}
                      />
                      <Form.Input
                        label={t('Contact No. {{count}}', { count: 2 })}
                        name="companyContactNo2"
                        fluid
                        value={project.companyContactNo2}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>
                    <Form.Group widths="equal">
                      <AppForm.Input
                        label={t('Email')}
                        name="companyEmail"
                        type="email"
                        fluid
                        value={project.companyEmail}
                        onChange={this.handleInputChange}
                        validation={[email]}
                        ref={this.validation.companyEmail}
                      />
                      <Form.Input
                        label={t('Others', { ns: TRANSLATION_FILES.constants })}
                        name="companyOthers"
                        fluid
                        value={project.companyOthers}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            {
              isMalaysia && this.hasCompanyHimsEnabled() ? (
                <Grid.Column stretched={!this.isActiveTab('hims_setup')} className={this.checkActiveTab('hims_setup')}>
                  <Divider horizontal>
                    <Form.Checkbox
                      label="HIMS Integration"
                      name="himsIsEnabled"
                      checked={project.himsIsEnabled}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Divider>
                  <Grid>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                      <AppForm.Select
                        label="Strata Project"
                        name="himsStrataIsEnabled"
                        value={project.himsStrataIsEnabled}
                        options={HIMS_STRATA_OPTIONS}
                        disabled={!project.himsIsEnabled || this.state.companyHimsTokensLoading}
                        validation={project.himsIsEnabled ? [required] : null}
                        ref={this.validation.himsStrataIsEnabled}
                        validateLabel="Strata Project"
                        onChange={this.handleInputChange}
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <Form.Checkbox
                        label="Hide HIMS Strata fields to agents"
                        name="himsStrataIsHidden"
                        checked={project.himsStrataIsHidden}
                        onChange={this.handleCheckBoxChange}
                        disabled={project.himsStrataIsEnabled !== 'yes' || !project.himsIsEnabled || this.state.companyHimsTokensLoading}
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                      <AppForm.Select
                        label="Default SPA lawyer representation in e-SPA"
                        name="himsDefaultSpaLawyerRepID"
                        value={project.himsDefaultSpaLawyerRepID}
                        options={HIMS_SPA_LAWYER_REP_OPTIONS}
                        disabled={!project.himsIsEnabled || this.state.companyHimsTokensLoading}
                        validation={project.himsIsEnabled ? [required] : null}
                        ref={this.validation.himsDefaultSpaLawyerRepID}
                        validateLabel="Default SPA lawyer representation in e-SPA"
                        onChange={this.handleInputChange}
                      />
                    </Grid.Column>
                  </Grid>
                  <Divider horizontal>HIMS Info</Divider>
                  <ProjectHimsSettingsForm
                    ref={this.himsSettingsForm}
                    projectID={project.id}
                    companyHimsTokens={this.state.companyHimsTokens}
                    onChange={this.handleOnHimsSettingsChange}
                    himsSettings={project.projectHimsSettings}
                    disabled={!project.himsIsEnabled || this.state.companyHimsTokensLoading}
                  />
                  <Divider horizontal>HIMS bookings</Divider>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column>
                        <Segment style={{ display: 'flex', justifyContent: 'center' }}>
                          <Button
                            type="button"
                            disabled={!project.himsIsEnabled || this.state.companyHimsTokensLoading}
                            onClick={() => this.handleUpdateHimsForBookings()}
                          >
                            <Icon name="refresh" />
                            Applies HIMS data to all HIMS enabled bookings
                          </Button>
                        </Segment>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              ) : null
            }
            <Grid.Column stretched className={this.checkActiveTab('setup')}>
              {this.hasAccess(true, true, true) &&
                <Divider horizontal>{t('Management')}</Divider>
              }
              {this.hasAccess(true, true, false) &&
                <div>
                  <p style={{ marginBottom: '4px', fontWeight: 'bold' }}>{translateModels(t, 'maOwnerCompanyBranchShortName', 'project')}*</p>
                  <SearchBranch
                    onClear={this.handleBranchClear}
                    onSelect={this.handleBranchSelect}
                    selectedValue={this.getSelectedBranchValue()}
                  />
                  <br />
                </div>
              }
              {this.hasAccess(true, true, false) &&
                <Form.Group grouped>
                  <Form.Checkbox
                    label={translateModels(t, 'isPublic', 'project')}
                    name="isPublic"
                    checked={project.isPublic}
                    onChange={this.handleCheckBoxChange}
                  />
                </Form.Group>
              }
              {this.hasAccess(true, true, true) &&
                <Form.Group grouped>
                  <Form.Group grouped>
                    <Form.Checkbox
                      label={translateModels(t, 'isLaunchMode', 'project')}
                      name="isLaunchMode"
                      checked={project.isLaunchMode}
                      onChange={this.handleCheckBoxChange}
                    />
                    <AppForm.Input
                      disabled={!project.isLaunchMode}
                      label={translateModels(t, 'launchModeMinutes', 'project')}
                      name="launchModeMinutes"
                      value={project.launchModeMinutes}
                      validation={[required, {
                        validate: numericRange,
                        option: {
                          min: project.isLaunchMode ? 1 : 0,
                        },
                      }]}
                      onChange={this.handleInputChange}
                      ref={this.validation.launchModeMinutes}
                      type="number"
                      pattern="[0-9]*"
                    />
                  </Form.Group>
                </Form.Group>
              }
              {this.hasAccess(true, true, true) &&
                <Form.Group grouped>
                  <Form.Group grouped>
                    <Form.Checkbox
                      disabled={!project.isLaunchMode}
                      label={translateModels(t, 'bapEnabledInLaunchMode', 'project')}
                      name="bapIsEnabled"
                      checked={project.bapIsEnabled}
                      onChange={this.handleCheckBoxChange}
                    />
                    <Form.Checkbox
                      disabled={!project.bapIsEnabled || !project.isLaunchMode}
                      label={translateModels(t, 'bapProjectWideMode', 'project')}
                      name="bapIsProjectMode"
                      checked={project.bapIsProjectMode}
                      onChange={this.handleCheckBoxChange}
                    />
                    <AppForm.Input
                      disabled={!project.bapIsEnabled || !project.isLaunchMode}
                      label={translateModels(t, 'bapMaxAttempts', 'project')}
                      name="bapMaxAttempts"
                      value={project.bapMaxAttempts}
                      validation={[required, {
                        validate: numericRange,
                        option: {
                          min: 1,
                        },
                      }]}
                      onChange={this.handleInputChange}
                      ref={this.validation.bapMaxAttempts}
                      type="number"
                      pattern="[0-9]*"
                    />
                    <DropdownInputNumber
                      disabled={!project.bapIsEnabled || !project.isLaunchMode}
                      label={translateModels(t, 'bapAttemptWindow', 'project')}
                      presetOptions={this.state.bapCooldownOptions}
                      placeholder="Attempt Window"
                      name="bapWindowMinutes"
                      search
                      selection
                      fluid
                      allowAdditions
                      value={project.bapWindowMinutes}
                      onChange={this.handleChangeBAPWindow}
                    />
                    <DropdownInputNumber
                      disabled={!project.bapIsEnabled || !project.isLaunchMode}
                      label={translateModels(t, 'bapCooldownPeriod', 'project')}
                      presetOptions={this.bapMinutesOptions}
                      placeholder="Cooldown Minutes"
                      name="bapCooldownMinutes"
                      search
                      selection
                      fluid
                      allowAdditions
                      value={project.bapCooldownMinutes}
                      onChange={this.handleChangeBAPCooldown}
                    />
                  </Form.Group>
                </Form.Group>
              }
              {(
                this.hasAccess(true, true, true) &&
                this.props.appConfig.data.onlinePaymentEnabled
              ) &&
                <Form.Group grouped>
                  <Form.Checkbox
                    label={translateModels(t, 'isAPDL', 'project')}
                    name="isAPDL"
                    checked={project.isAPDL}
                    onChange={this.handleCheckBoxChange}
                  />
                </Form.Group>
              }
              <Divider horizontal>{t('Unit Agency Allocation', { ns: TRANSLATION_FILES.translation })}</Divider>
              <Form.Select
                label={t('Agency Allocation Logic', { ns: TRANSLATION_FILES.translation })}
                name="agencyAllocationAllocateAll"
                options={[
                  { key: 'allocateToAll', text: t('Allocate to all', { ns: TRANSLATION_FILES.translation }), value: true },
                  { key: 'allocateToNone', text: t('Allocate to none', { ns: TRANSLATION_FILES.translation }), value: false },
                ]}
                value={Boolean(project.agencyAllocationAllocateAll)}
                onChange={this.handleInputChange}
                selection
                fluid
              />
              {this.hasAccess(true, true, true) && (
                <Divider horizontal>{t('MHub Buyer App')}</Divider>
              )}
              {this.hasAccess(true, true, true) && (
                <Form.Group grouped>
                  <Form.Checkbox
                    label={translateModels(t, 'linkBuyerApp', 'project')}
                    name="linkBuyerApp"
                    checked={project.linkBuyerApp}
                    onChange={this.handleCheckBoxChange}
                  />
                </Form.Group>
              )}
              {this.hasAccess(true, true, false) && (
                <Divider horizontal>{t('MHub Bot')}</Divider>
              )}
              {this.hasAccess(true, true, false) && (
                <Form.Group grouped>
                  <Form.Checkbox
                    label={translateModels(t, 'isBotEnabled', 'project')}
                    name="isBotEnabled"
                    checked={project.isBotEnabled}
                    onChange={this.handleCheckBoxChange}
                  />
                </Form.Group>
              )}
              {this.hasAccess(true, true, true) && this.props.appConfig.data.creditControlIsEnabled && (
                <Divider horizontal>{t('Credit Control')}</Divider>
              )}
              {this.props.appConfig.data.creditControlIsEnabled && (
                <Form.Group grouped>
                  {this.hasAccess(true, true, true) && (
                    <Form.Checkbox
                      label={translateModels(t, 'creditControlIsUnlinked', 'project')}
                      name="creditControlIsUnlinked"
                      checked={project.creditControlIsUnlinked}
                      onChange={this.handleCheckBoxChange}
                    />
                  )}
                  {this.hasAccess(true, false, false, false, true) && (
                    <Form.Checkbox
                      label={translateModels(t, 'allowPurchaserEditAfterSold', 'project')}
                      name="allowPurchaserEditAfterSold"
                      checked={project.allowPurchaserEditAfterSold}
                      onChange={this.handleCheckBoxChange}
                      style={{ marginLeft: '20px' }}
                    />
                  )}
                  {this.hasAccess(true, false, false, false, true) && (
                    <Form.Checkbox
                      label={translateModels(t, 'allowPricingEditAfterSold', 'project')}
                      name="allowPricingEditAfterSold"
                      checked={project.allowPricingEditAfterSold}
                      onChange={this.handleCheckBoxChange}
                      style={{ marginLeft: '20px' }}
                    />
                  )}
                  {/* {this.hasAccess(true, true, true) && (
                    <Form.Checkbox
                      label={translateModels(t, 'autoGenerateBillingAfterSold', 'project')}
                      name="autoGenerateBillingAfterSold"
                      checked={project.autoGenerateBillingAfterSold}
                      onChange={this.handleCheckBoxChange}
                      disabled={project.creditControlIsUnlinked}
                      style={{ marginLeft: '20px' }}
                    />
                  )} */}
                  {/* {this.hasAccess(true, true, true) && (
                    <Select
                      label={translateModels(t, 'billingDateSource', 'project')}
                      name="billingDateSource"
                      fluid
                      onChange={this.handleInputChange}
                      value={project.billingDateSource}
                      options={billingDateSources}
                      disabled={!project.autoGenerateBillingAfterSold}
                      style={{ marginLeft: '20px' }}
                    />
                  )} */}
                  {this.hasAccess(true, true, true) && (
                    <Form.Checkbox
                      label={translateModels(t, 'isCreditControlRebateUpdateDisabled', 'project')}
                      name="isCreditControlRebateUpdateDisabled"
                      checked={project.isCreditControlRebateUpdateDisabled}
                      onChange={this.handleCheckBoxChange}
                    />
                  )}
                </Form.Group>
              )}
              {isMalaysia && this.hasAccess(true, false, false, false, true) && (
                <Divider horizontal>{translateModels(t, 'HLB Campaign', 'project')}</Divider>
              )}
              {isMalaysia && this.hasAccess(true, false, false, false, true) && (
                <Form.Group grouped>
                  <Form.Checkbox
                    label={translateModels(t, 'enableHLBCampaign', 'project')}
                    name="hlbCampaignIsEnabled"
                    checked={project.hlbCampaignIsEnabled}
                    onChange={this.handleCheckBoxChange}
                  />
                </Form.Group>
              )}
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('booking_setup')}>
              <Divider horizontal>{t('Loan Tracker')}</Divider>
              <Form.Checkbox
                label={t('Consent SMS PIN required')}
                name="loanTrackerProjectConsentTypeID"
                checked={project.loanTrackerProjectConsentTypeID === '2'}
                onChange={this.handleConsentCheck}
              />
              <Form.Group grouped>
                <Form.Group grouped>
                  <Form.Checkbox
                    label={translateModels(t, 'loanTrackerDirectConsent', 'project')}
                    name="loanTrackerDirectConsent"
                    disabled
                    checked={project.loanTrackerDirectConsent}
                    onChange={this.handleCheckBoxChange}
                  />
                </Form.Group>
              </Form.Group>
              <Divider horizontal>{t('Booking Flow')}</Divider>
              <Form.Group grouped>
                <Form.Group grouped>
                  { isPRS &&
                    <Form.Checkbox
                      label={translateModels(t, 'customerAssessmentFlow', 'project')}
                      name="customerAssessmentFlow"
                      checked={project.customerAssessmentFlow}
                      onChange={this.handleCheckBoxChange}
                    />
                  }
                  <Form.Checkbox
                    label={translateModels(t, 'paymentFlow', 'project')}
                    name="paymentFlow"
                    checked={project.paymentFlow}
                    onChange={this.handleCheckBoxChange}
                  />
                  <Form.Checkbox
                    label={translateModels(t, 'loanTrackerDirectShow', 'project')}
                    name="loanTrackerDirectShow"
                    checked={project.loanTrackerDirectShow}
                    onChange={this.handleCheckBoxChange}
                  />
                </Form.Group>
              </Form.Group>
              { isVietnamCompany && (
                <Form.Group grouped>
                  {/*
                  Hidden: no place to enter a payment on a Vietnamese Sales Overview since CPI-974; re-enable when the payment section returns.
                  <Header as="h5" style={{ margin: '0 0 5px 0' }}>
                    {translateModels(t, 'paymentApprovedRequiredStatusIDs', 'project')}
                  </Header>
                  <Dropdown
                    name="paymentApprovedRequiredStatusIDs"
                    fluid
                    multiple
                    search
                    selection
                    options={paymentApprovedRequiredStatusOptions}
                    onChange={this.handleInputChange}
                    value={project.paymentApprovedRequiredStatusIDs || []}
                    style={{ marginBottom: '10px' }}
                  />
                  */}
                  <Form.Checkbox
                    label={translateModels(t, 'signatureRequiredForBooked', 'project')}
                    name="signatureRequiredForBooked"
                    checked={!!project.signatureRequiredForBooked}
                    onChange={this.handleCheckBoxChange}
                  />
                </Form.Group>
              )}
              <Divider horizontal>{t('Source of Financing')}</Divider>
              <Form.Group grouped>
                <Form.Group className="form-label">
                  <Form.Field width={10}>
                    <Segment className="form-sof-segment" >
                      <Header as="h4">{t('Visibility settings')}</Header>
                      { enabledFinanceSources.length > 0 && enabledFinanceSources.map(fs => this.renderFinanceSourceItem(fs.id)) }
                    </Segment>
                  </Form.Field>
                </Form.Group>
              </Form.Group>
              {
                isPRS && (
                  <div>
                    <Divider horizontal>{t('Auto-Release')}</Divider>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column mobile={16} tablet={4} computer={4}>
                          <Form.Group className="form-label">
                            <Form.Field label={t('Upload Buyer\'s IC')} />
                          </Form.Group>
                          <Form.Group className="form-mb1">
                            <Form.Field>
                              <Segment>
                                <Form.Checkbox
                                  toggle
                                  label={t(project.arBookingExpNricPicIsEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="arBookingExpNricPicIsEnabled"
                                  checked={project.arBookingExpNricPicIsEnabled}
                                  onChange={this.handleCheckBoxChange}
                                  disabled={!project.arBookingExpIsEnabled || !systemData.arBookingExpIsEnabled}
                                />
                              </Segment>
                            </Form.Field>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={4} computer={4}>
                          <Form.Group className="form-label">
                            <Form.Field label={t('Booking fee payment')} />
                          </Form.Group>
                          <Form.Group className="form-mb1">
                            <Form.Field>
                              <Segment>
                                <Form.Checkbox
                                  toggle
                                  label={t(project.arBookingExpUnpaidIsEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="arBookingExpUnpaidIsEnabled"
                                  checked={project.arBookingExpUnpaidIsEnabled}
                                  onChange={this.handleCheckBoxChange}
                                  disabled={!project.arBookingExpIsEnabled || !systemData.arBookingExpIsEnabled}
                                />
                              </Segment>
                            </Form.Field>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                          <Form.Group className="form-label">
                            <Form.Field label={t('Mortgage')} />
                          </Form.Group>
                          <Form.Group className="form-mb1">
                            <Form.Field>
                              <Segment>
                                <Form.Checkbox
                                  toggle
                                  label={t(project.arBookingExpMortgageEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="arBookingExpMortgageEnabled"
                                  checked={project.arBookingExpMortgageEnabled}
                                  onChange={this.handleCheckBoxChange}
                                  disabled={!project.arBookingExpIsEnabled || !systemData.arBookingExpIsEnabled}
                                />
                              </Segment>
                            </Form.Field>
                          </Form.Group>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </div>
                )
              }
              <Divider horizontal>{t('Email notification')}</Divider>
              <Form.Field>
                <label htmlFor="manualSize">{t('New Booking')}</label>
                <AppForm.Validate
                  ref={this.validation.newBookingEmailNotifications}
                  onChange={(e, { value }) => this.handleAddEmail(e, value, 'newBookingEmailNotifications')}
                >
                  <Dropdown
                    name="newBookingEmailNotifications"
                    options={
                      project && project.newBookingEmailNotifications ?
                        project.newBookingEmailNotifications.map(eml => ({
                          text: eml,
                          value: eml,
                        })) :
                        []
                    }
                    placeholder={t('Add emails')}
                    noResultsMessage={t('Add emails')}
                    search
                    selection
                    fluid
                    multiple
                    allowAdditions
                    value={
                      project && project.newBookingEmailNotifications ?
                        project.newBookingEmailNotifications :
                        []
                    }
                  />
                </AppForm.Validate>
              </Form.Field>
              <Form.Field>
                <label htmlFor="manualSize">{t('Approved Booking')}</label>
                <AppForm.Validate
                  ref={this.validation.approvedBookingEmailNotifications}
                  onChange={(e, { value }) => this.handleAddEmail(e, value, 'approvedBookingEmailNotifications')}
                >
                  <Dropdown
                    name="approvedBookingEmailNotifications"
                    options={
                      project && project.approvedBookingEmailNotifications ?
                        project.approvedBookingEmailNotifications.map(eml => ({
                          text: eml,
                          value: eml,
                        })) :
                        []
                    }
                    placeholder={t('Add emails')}
                    noResultsMessage={t('Add emails')}
                    search
                    selection
                    fluid
                    multiple
                    allowAdditions
                    value={
                      project && project.approvedBookingEmailNotifications ?
                        project.approvedBookingEmailNotifications :
                        []
                    }
                  />
                </AppForm.Validate>
              </Form.Field>
              <Form.Field>
                <label htmlFor="manualSize">{t('Cancelled Booking')}</label>
                <AppForm.Validate
                  ref={this.validation.cancelledBookingEmailNotifications}
                  onChange={(e, { value }) => this.handleAddEmail(e, value, 'cancelledBookingEmailNotifications')}
                >
                  <Dropdown
                    name="cancelledBookingEmailNotifications"
                    options={
                      project && project.cancelledBookingEmailNotifications ?
                        project.cancelledBookingEmailNotifications.map(eml => ({
                          text: eml,
                          value: eml,
                        })) :
                        []
                    }
                    placeholder={t('Add emails')}
                    noResultsMessage={t('Add emails')}
                    search
                    selection
                    fluid
                    multiple
                    allowAdditions
                    value={
                      project && project.cancelledBookingEmailNotifications ?
                        project.cancelledBookingEmailNotifications :
                        []
                    }
                  />
                </AppForm.Validate>
              </Form.Field>
              <Form.Field>
                <label htmlFor="manualSize">{t('Sold Booking')}</label>
                <AppForm.Validate
                  ref={this.validation.soldStatusBookingEmailNotifications}
                  onChange={(e, { value }) => this.handleAddEmail(e, value, 'soldStatusBookingEmailNotifications')}
                >
                  <Dropdown
                    name="soldStatusBookingEmailNotifications"
                    options={
                      project && project.soldStatusBookingEmailNotifications ?
                        project.soldStatusBookingEmailNotifications.map(eml => ({
                          text: eml,
                          value: eml,
                        })) :
                        []
                    }
                    placeholder={t('Add emails')}
                    noResultsMessage={t('Add emails')}
                    search
                    selection
                    fluid
                    multiple
                    allowAdditions
                    value={
                      project && project.soldStatusBookingEmailNotifications ?
                        project.soldStatusBookingEmailNotifications :
                        []
                    }
                  />
                </AppForm.Validate>
              </Form.Field>
              <Form.Checkbox
                label={translateModels(t, 'allowAgentReceiveCancelledBookingEmail', 'project')}
                name="allowAgentReceiveCancelledBookingEmail"
                checked={project.allowAgentReceiveCancelledBookingEmail}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'sendCustomerCancelledBookingEmail', 'project')}
                name="sendCustomerCancelledBookingEmail"
                checked={project.sendCustomerCancelledBookingEmail}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'sendCustomerSuccessBookingEmail', 'project')}
                name="sendCustomerSuccessBookingEmail"
                checked={project.sendCustomerSuccessBookingEmail}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Select
                label={translateModels(t, 'customerBookingSuccessEmailType', 'project')}
                name="customerBookingSuccessEmailType"
                fluid
                onChange={this.handleInputChange}
                value={project.customerBookingSuccessEmailType}
                options={customerBookingSuccessEmailTypes}
                disabled={!project.sendCustomerSuccessBookingEmail}
              />
              <Divider horizontal>{t('Conversion Details')}</Divider>
              <Form.Checkbox
                label="Allow HQ and Supervisor to edit conversion details (Bank Name, Banker Name, Loan Margin, Loan Amount) in booking info"
                name="allowEditConversionDetailsIsEnabled"
                checked={project.allowEditConversionDetailsIsEnabled}
                onChange={this.handleCheckBoxChange}
                disabled={!this.props.auth.isHeadquarters}
              />
              <Divider horizontal>{t('Reservations/Bookings')}</Divider>
              <Form.Select
                label={t('Bankers Limit')}
                name="loanTrackerProjectLeadBankersLimit"
                fluid
                onChange={this.handleInputChange}
                value={project.loanTrackerProjectLeadBankersLimit}
                options={Array(16).fill('Unlimited').map((text, key) => ({
                  text: key === 0 ? text : key.toString(),
                  value: key,
                  name: key,
                }))}
              />
              <AppForm.Input
                label={translateModels(t, 'bookingUnitLimit', 'project')}
                name="bookingUnitLimit"
                value={project.bookingUnitLimit}
                validation={[required, {
                  validate: numericRange,
                  option: {
                    min: 1,
                  },
                }]}
                onChange={this.handleInputChange}
                ref={this.validation.bookingUnitLimit}
                type="number"
                pattern="[0-9]*"
              />
              { project.bookingUnitLimit > 1 && (
                <Form.Checkbox
                  label={translateModels(t, 'activeBookingsInUnits', 'project')}
                  name="activeBookingsInUnits"
                  checked={project.activeBookingsInUnits}
                  onChange={this.handleCheckBoxChange}
                />
              )}
              { project.bookingUnitLimit > 1 && (
                <Form.Checkbox
                  label={translateModels(t, 'activeBookingsIncludeWaitlist', 'project')}
                  name="activeBookingsIncludeWaitlist"
                  checked={project.activeBookingsIncludeWaitlist}
                  onChange={this.handleCheckBoxChange}
                  disabled={!project.activeBookingsInUnits}
                />
              )}
              <Divider horizontal>{t('Customer Reservation Limit')}</Divider>
              <Form.Checkbox
                label={translateModels(t, 'customerReservationLimitIsEnabled', 'project')}
                name="customerReservationLimitIsEnabled"
                checked={project.customerReservationLimitIsEnabled}
                onChange={this.handleCheckBoxChange}
              />
              <AppForm.Input
                label={translateModels(t, 'customerReservationMaxLimit', 'project')}
                name="customerReservationMaxLimit"
                value={project.customerReservationMaxLimit}
                validation={[required, {
                  validate: numericRange,
                  option: {
                    min: 1,
                  },
                }]}
                onChange={this.handleInputChange}
                ref={this.validation.customerReservationMaxLimit}
                type="number"
                pattern="[0-9]*"
                disabled={!project.customerReservationLimitIsEnabled}
              />
              <Form.Select
                label={translateModels(t, 'customerReservationLimitStatusIDs', 'project')}
                name="customerReservationLimitStatusIDs"
                fluid
                multiple
                disabled={!project.customerReservationLimitIsEnabled}
                search
                selection
                options={BOOKING_STATUSES.map(s => ({
                  ...s,
                  text: t(s.text, { ns: TRANSLATION_FILES.constants }),
                }))}
                onChange={this.handleInputChange}
                value={project.customerReservationLimitStatusIDs}
                style={{ marginBottom: '10px' }}
              />
              <Divider horizontal>{t('New Reservation/Booking Form')}</Divider>
              <Form.Select
                label={translateModels(t, 'defaultCustomBookingStatusID', 'project')}
                name="defaultCustomBookingStatusID"
                fluid
                onChange={this.handleInputChange}
                value={project.defaultCustomBookingStatusID}
                options={this.defaultBookingStatutes.map(s => ({
                  ...s,
                  text: t(s.text, { ns: TRANSLATION_FILES.constants }),
                }))}
              />
              <Form.Checkbox
                label={translateModels(t, 'allowCustomBookingStatus', 'project')}
                name="allowCustomBookingStatus"
                checked={project.allowCustomBookingStatus}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'allowStaffEditBookingSPAValue', 'project')}
                name="allowStaffEditBookingSPAValue"
                checked={project.allowStaffEditBookingSPAValue}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'allowAgentEditBookingSPAValue', 'project')}
                name="allowAgentEditBookingSPAValue"
                checked={project.allowAgentEditBookingSPAValue}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'allowAgentAutofillPurchaserDetails', 'project')}
                name="allowAgentAutofillPurchaserDetails"
                checked={project.allowAgentAutofillPurchaserDetails}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'showPurchaserExtraFields', 'project')}
                name="showPurchaserExtraFields"
                checked={project.showPurchaserExtraFields}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'requirePricingSelectDuringReserve', 'project')}
                name="requirePricingSelectDuringReserve"
                checked={project.requirePricingSelectDuringReserve}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'disableBaseSellingPriceSelection', 'project')}
                name="disableBaseSellingPriceSelection"
                checked={project.disableBaseSellingPriceSelection}
                onChange={this.handleCheckBoxChange}
              />
              {/* CPI-1372: in Vietnam this box also hides every price from Agency users on Unit
                  Information and the Sales exports. The label is shared with Malaysia / Indonesia,
                  where the box keeps its single meaning, so the wider scope is a VN-only note. */}
              {isVietnamCompany && (
                <p style={{ margin: '-0.5em 0 1em 1.85em', opacity: 0.6 }}>
                  {t('When enabled, Agency users also see no prices on Unit Information and the Sales exports', { ns: TRANSLATION_FILES.screens })}
                </p>
              )}
              <Divider horizontal>
                <Form.Checkbox
                  label={translateModels(t, 'rduIsEnabled', 'project')}
                  name="rduIsEnabled"
                  checked={project.rduIsEnabled}
                  onChange={this.handleCheckBoxChange}
                />
              </Divider>
              <Header
                as="h5"
                style={project.rduIsEnabled ? { margin: '0 0 5px 0' } : { margin: '0 0 5px 0', opacity: '0.45' }}
              >
                {translateModels(t, 'rduAccessGroupIDs', 'project')}
              </Header>
              <Dropdown
                name="rduAccessGroupIDs"
                fluid
                multiple
                disabled={!project.rduIsEnabled}
                search
                selection
                options={rduAccessesOptions.map(opt => ({
                  ...opt,
                  text: t(opt.text, { ns: TRANSLATION_FILES.constants }),
                }))}
                onChange={this.handleInputChange}
                value={project.rduAccessGroupIDs || []}
                style={{ marginBottom: '10px' }}
              />
              <Divider horizontal>{t('Reservation/Booking Overview Page')}</Divider>
              <Form.Checkbox
                label={translateModels(t, 'allowAgentManageBooking', 'project')}
                name="allowAgentManageBooking"
                checked={project.allowAgentManageBooking}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'allowAgentManageBookingCustomer', 'project')}
                name="allowAgentManageBookingCustomer"
                checked={project.allowAgentManageBookingCustomer}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'allowAgentChangeBookingPaymentMethod', 'project')}
                name="allowAgentChangeBookingPaymentMethod"
                checked={project.allowAgentChangeBookingPaymentMethod}
                onChange={this.handleCheckBoxChange}
              />
              {/* CPI-1212: Vietnam-only switch, default off, so a Vietnam project starts with
                  Source of Finance read-only for a base agent. Malaysia and Indonesia never
                  render it. Deliberately a field of its own and NOT the payment-details flag
                  above, which defaults to on. Enforced in book-api handlers/bookings.go. */}
              { isVietnamCompany && (
                <Form.Checkbox
                  label={translateModels(t, 'allowAgentEditSourceOfFinance', 'project')}
                  name="allowAgentEditSourceOfFinance"
                  checked={!!project.allowAgentEditSourceOfFinance}
                  onChange={this.handleCheckBoxChange}
                />
              )}
              <Form.Checkbox
                label={translateModels(t, 'allowAgentEditBookingFee', 'project')}
                name="allowAgentEditBookingFee"
                checked={project.allowAgentEditBookingFee}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'allowAgentCancelBookingFee', 'project')}
                name="allowAgentCancelBookingFee"
                checked={project.allowAgentCancelBookingFee}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'allowAgentChangePrimaryPurchaser', 'project')}
                name="allowAgentChangePrimaryPurchaser"
                checked={project.allowAgentChangePrimaryPurchaser}
                onChange={this.handleCheckBoxChange}
              />
              <Divider horizontal>{t('Share E-Signature')}</Divider>
              <Form.Checkbox
                label={translateModels(t, 'shareESignIsEnabled', 'project')}
                name="shareESignIsEnabled"
                checked={project.shareESignIsEnabled}
                onChange={this.handleCheckBoxChange}
              />
              {/* <Form.Checkbox
                label={translateModels(t, 'shareESignPinIsRequired', 'project')}
                name="shareESignPinIsRequired"
                checked={project.shareESignPinIsRequired}
                onChange={this.handleCheckBoxChange}
              /> */}
              <Form.Checkbox
                label={translateModels(t, 'shareESignAllowPreviewForm', 'project')}
                name="shareESignAllowPreviewForm"
                checked={project.shareESignAllowPreviewForm}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'shareESignSendFormsEmail', 'project')}
                name="shareESignSendFormsEmail"
                checked={project.shareESignSendFormsEmail}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'allowAgentShareESign', 'project')}
                name="allowAgentShareESign"
                checked={project.allowAgentShareESign}
                onChange={this.handleCheckBoxChange}
              />
              <Divider horizontal>{t('Booking Printing')}</Divider>
              <Form.Select
                label={
                  <label htmlFor="printType">
                    {translateModels(t, 'printType', 'project')}
                    {docxPrintIsSelected && <i style={{ color: 'grey', marginLeft: '1em' }}>*Form already selected in Form Template</i>}
                  </label>
                }
                name="printType"
                fluid
                onChange={this.handleInputChange}
                value={project.printType}
                options={printTypes}
                disabled={docxPrintIsSelected}
              />
              {/* <Header
                as="h5"
                style={{ margin: '0 0 5px 0' }}
              >
                Bob Forms
              </Header>
              <Dropdown
                name="bobFormIDs"
                fluid
                multiple
                search
                selection
                options={bobTypes}
                onChange={this.handleInputChange}
                value={project.bobFormIDs ? project.bobFormIDs : []}
                style={{ marginBottom: '10px' }}
              /> */}
              <Header
                as="h5"
                style={{ margin: '0 0 5px 0' }}
              >
                {translateModels(t, 'formAccessibilitiesTemplateIDs', 'project')}
              </Header>
              <Dropdown
                name="formAccessibilitiesTemplateIDs"
                fluid
                multiple
                search
                selection
                options={printTypes}
                onChange={this.handleInputChange}
                value={formAccessibilitiesTemplateIDs}
                style={{ marginBottom: '10px' }}
              />
              {
                project.projectFormAccessibilities && project.projectFormAccessibilities.length > 0 ? (
                  <Form.Checkbox
                    label={translateModels(t, 'printPDF', 'project')}
                    name="printPDF"
                    checked={project.printPDF}
                    onChange={this.handleCheckBoxChange}
                  />
                ) : null
              }
              {
                project.printType !== 'none' || project.projectFormAccessibilities !== null ? (
                  <Form.TextArea
                    label={translateModels(t, 'printClause', 'project')}
                    name="printClause"
                    value={project.printClause}
                    onChange={this.handleInputChange}
                  />
                ) : null
              }
              <Form.Input
                autoComplete="off"
                fluid
                label={translateModels(t, 'customWatermark', 'project')}
                name="customWatermark"
                value={project.customWatermark}
                onChange={this.handleInputChange}
              />
              {
                project.printType !== 'none' && project.printClause ? (
                  <Form.Field name="printClausePreview">
                    <label htmlFor="printClausePreview">{t('Preview', { ns: TRANSLATION_FILES.translation })}</label>
                    <MarkdownText content={project.printClause} />
                  </Form.Field>
                ) : null
              }
              <Form.Checkbox
                label={translateModels(t, 'hidePrintAgentStaff', 'project')}
                name="hidePrintAgentStaff"
                checked={project.hidePrintAgentStaff}
                onChange={this.handleCheckBoxChange}
              />
              <Form.Checkbox
                label={translateModels(t, 'allowSendFormsEmail', 'project')}
                name="allowSendFormsEmail"
                checked={project.allowSendFormsEmail}
                onChange={this.handleCheckBoxChange}
              />
              <Divider horizontal>
                <Form.Checkbox
                  label={translateModels(t, 'autofillFromUrl', 'project')}
                  name="autofillFromUrl"
                  checked={project.autofillFromUrl}
                  onChange={this.handleCheckBoxChange}
                />
              </Divider>
              <Form.Group widths="equal">
                <AppForm.Input
                  label={translateModels(t, 'externalAutofillUrl', 'project')}
                  name="externalAutofillUrl"
                  value={project.externalAutofillUrl || ''}
                  onChange={this.handleInputChange}
                  disabled={!project.autofillFromUrl}
                />
              </Form.Group>
              {
                project.projectFormAccessibilities ?
                  <BookingFormTemplateList
                    data={pTemplates
                    .filter(pt => formAccessibilitiesTemplateIDs.includes(pt.id)) || []}
                    loading={this.state.loading}
                    handleSaveTemplateToggle={(id, v) => {
                      this.handleSaveTemplateToggle(id, v);
                    }}
                  /> : null
              }
              <Divider horizontal>
                <Form.Checkbox
                  label={translateModels(t, 'cuIsEnabled', 'project')}
                  name="cuIsEnabled"
                  checked={project.cuIsEnabled}
                  onChange={this.handleCheckBoxChange}
                />
              </Divider>
              <Form.Checkbox
                label={t('Change unit within same project')}
                name="cuIsEnabled"
                checked={project.cuIsEnabled}
                disabled
              />
              {/* CPI-1464: hidden from a Vietnamese tenant's users; an MHub admin still sees both, with a
                  note that the tenant cannot. book-api refuses the two fields from any other Vietnamese
                  save, so what the admin sees here is what the change-unit flow enforces. */}
              {!hideChangeUnitOptions && (
                <Form.Checkbox
                  label={translateModels(t, 'cuOtherProjectIsEnabled', 'project')}
                  name="cuOtherProjectIsEnabled"
                  checked={project.cuOtherProjectIsEnabled}
                  onChange={this.handleCheckBoxChange}
                  disabled={!project.cuIsEnabled}
                />
              )}
              {!hideChangeUnitOptions && (
                <Form.Checkbox
                  label={translateModels(t, 'cuDelistOnHoldIsEnabled', 'project')}
                  name="cuDelistOnHoldIsEnabled"
                  checked={project.cuDelistOnHoldIsEnabled}
                  onChange={this.handleCheckBoxChange}
                  disabled={!project.cuIsEnabled}
                />
              )}
              {isVietnamCompany && !hideChangeUnitOptions && (
                <p style={{ margin: '-0.5em 0 1em 1.85em', opacity: 0.6 }}>
                  {t('The two options above are hidden from this company\'s users. Only MHub admin can see and change them.', { ns: TRANSLATION_FILES.screens })}
                </p>
              )}
              <Form.Checkbox
                label={translateModels(t, 'cuFollowPrevBookingDateIsEnabled', 'project')}
                name="cuFollowPrevBookingDateIsEnabled"
                checked={project.cuFollowPrevBookingDateIsEnabled}
                onChange={this.handleCheckBoxChange}
                disabled={!project.cuIsEnabled}
              />
              <Form.Checkbox
                label={translateModels(t, 'cuDefaultFollowPrevBookingDateIsEnabled', 'project')}
                name="cuDefaultFollowPrevBookingDateIsEnabled"
                checked={project.cuDefaultFollowPrevBookingDateIsEnabled}
                onChange={this.handleCheckBoxChange}
                disabled={!project.cuIsEnabled || !project.cuFollowPrevBookingDateIsEnabled}
                style={{ marginLeft: '20px' }}
              />
              <Form.Checkbox
                label={translateModels(t, 'cuDisabledEditingOfFollowPrevBookingDate', 'project')}
                name="cuDisabledEditingOfFollowPrevBookingDate"
                checked={project.cuDisabledEditingOfFollowPrevBookingDate}
                onChange={this.handleCheckBoxChange}
                disabled={!project.cuIsEnabled || !project.cuDefaultFollowPrevBookingDateIsEnabled}
                style={{ marginLeft: '40px' }}
              />
              <Form.Checkbox
                label={translateModels(t, 'cuAttachmentsRequired', 'project')}
                name="cuAttachmentsRequired"
                checked={project.cuAttachmentsRequired}
                onChange={this.handleCheckBoxChange}
                disabled={!project.cuIsEnabled}
              />
              <Form.Checkbox
                label={translateModels(t, 'cuReserveNewBooking', 'project')}
                name="cuReserveNewBooking"
                checked={project.cuReserveNewBooking}
                onChange={this.handleCheckBoxChange}
                disabled={!project.cuIsEnabled}
              />
              <Form.Checkbox
                label={translateModels(t, 'cuReactivatePrevBooking', 'project')}
                name="cuReactivatePrevBooking"
                checked={project.cuReactivatePrevBooking}
                onChange={this.handleCheckBoxChange}
                disabled={!project.cuIsEnabled || !project.cuReserveNewBooking}
                style={{ marginLeft: '20px' }}
              />
              <Header
                as="h5"
                style={project.cuIsEnabled ? { margin: '0 0 5px 0' } : { margin: '0 0 5px 0', opacity: '0.45' }}
              >
                {translateModels(t, 'cuRoleAccesses', 'project')}
              </Header>
              <AppForm.Select
                name="cuRoleAccesses"
                ref={this.validation.cuRoleAccesses}
                validate
                fluid
                multiple
                disabled={!project.cuIsEnabled}
                search
                selection
                options={changeUnitAccessesOptions.map(opt => ({
                  ...opt,
                  text: t(opt.text, { ns: TRANSLATION_FILES.constants }),
                }))}
                onChange={this.handleInputChange}
                value={project.cuRoleAccesses || []}
                style={{ marginBottom: '10px' }}
              />
              { isCUExternalSelected &&
                <Form.Checkbox
                  label={translateModels(t, 'cuAllowExternalReserved', 'project')}
                  name="cuAllowExternalReserved"
                  checked={project.cuAllowExternalReserved}
                  onChange={this.handleCheckBoxChange}
                  disabled={!project.cuIsEnabled}
                />
              }
              { isCUExternalSelected &&
                <Form.Checkbox
                  label={translateModels(t, 'cuAllowExternalBooked', 'project')}
                  name="cuAllowExternalBooked"
                  checked={project.cuAllowExternalBooked}
                  onChange={this.handleCheckBoxChange}
                  disabled={!project.cuIsEnabled}
                />
              }
              { isCUExternalSelected &&
                <Form.Checkbox
                  label={translateModels(t, 'cuDisableExtEditCancelCriteria', 'project')}
                  name="cuDisableExtEditCancelCriteria"
                  checked={project.cuDisableExtEditCancelCriteria}
                  onChange={this.handleCheckBoxChange}
                  disabled={!project.cuIsEnabled}
                />
              }
              {isMalaysia && (
                <React.Fragment>
                  <Divider horizontal>Tax Identification Number</Divider>
                  <Form.Checkbox
                    label="Compulsory to fill in and validate Tax Identification Number during booking creation"
                    name="requireValidTinAtBookingCreation"
                    checked={project.requireValidTinAtBookingCreation}
                    onChange={this.handleCheckBoxChange}
                  />
                  <Grid>
                    <Grid.Row>
                      <Grid.Column>
                        <Form as="div">
                          <Form.Group widths="equal">
                            <Form.Field width={10} style={{ maxWidth: '70%' }}>
                              <Form.Checkbox
                                label="Compulsory to have valid Tax Identification Number before update booking to"
                                name="compulsoryValidTinBeforeUpdateBooking"
                                checked={this.state.compulsoryValidTinBeforeUpdateBooking}
                                onChange={this.handleCheckBoxChange}
                              />
                            </Form.Field>
                            <Form.Field width={2} style={{ maxWidth: '30%', marginLeft: window.innerWidth < 768 ? '2em' : '0', marginTop: '-0.5em' }}>
                              <Form.Select
                                disabled={!this.state.compulsoryValidTinBeforeUpdateBooking}
                                name="tinDropdown"
                                onChange={this.handleInputChange}
                                value={this.state.tinDropdown}
                                options={BOOKING_STATUSES_TIN_VALIDATION.map(opt => ({
                                  ...opt,
                                  text: opt.text,
                                }))}
                              />
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  <Header
                    as="h5"
                    style={{ margin: '0 0 1rem 2rem' }}
                  >
                    Apply the setting above to:
                  </Header>
                  <Form.Field style={{ margin: '0 0 1rem 1rem' }}>
                    <Form.Checkbox
                      radio
                      disabled={!this.state.compulsoryValidTinBeforeUpdateBooking}
                      label="All bookings"
                      name="tinSettingBookingStartAt"
                      checked={project.tinSettingBookingStartAt === null}
                      value=""
                      onChange={this.handleCheckBoxChange}
                    />
                    <Form.Checkbox
                      radio
                      disabled={!this.state.compulsoryValidTinBeforeUpdateBooking}
                      label="Bookings from start date"
                      name="tinSettingBookingStartAt"
                      checked={project.tinSettingBookingStartAt !== null}
                      onChange={this.handleCheckBoxChange}
                    />
                    {project.tinSettingBookingStartAt !== null && (
                      <Form.Field>
                        <DateTimePicker
                          visible={this.state.compulsoryValidTinBeforeUpdateBooking}
                          onChange={(value, visible) => this.handleTinSettingDateTimeInputChange(value, visible)}
                          value={project.tinSettingBookingStartAt ? moment(project.tinSettingBookingStartAt).toDate() : moment().toDate()}
                        />
                      </Form.Field>
                    )}
                  </Form.Field>
                </React.Fragment>
              )}
              <Divider horizontal>{t('Notes')}</Divider>
              <Header
                as="h5"
                style={{ margin: '0 0 5px 0' }}
              >
                {translateModels(t, 'bnEmailTitle', 'project')}
              </Header>
              <Form.Checkbox
                label={translateModels(t, 'bnEmailIsEnabled', 'project')}
                name="bnEmailIsEnabled"
                checked={project.bnEmailIsEnabled}
                onChange={this.handleCheckBoxChange}
              />
              <Header
                as="h5"
                style={{ margin: '0 0 5px 0' }}
              >
                {translateModels(t, 'bnReadAccessGroupIDs', 'project')}
              </Header>
              <Dropdown
                name="bnReadAccessGroupIDs"
                fluid
                multiple
                search
                selection
                options={bookingNoteAccessesOptions.map(opt => ({
                  ...opt,
                  text: t(opt.text, { ns: TRANSLATION_FILES.constants }),
                }))}
                onChange={this.handleInputChange}
                value={project.bnReadAccessGroupIDs || []}
                style={{ marginBottom: '10px' }}
              />
              <Header
                as="h5"
                style={{ margin: '0 0 5px 0' }}
              >
                {translateModels(t, 'bnWriteAccessGroupIDs', 'project')}
              </Header>
              <Dropdown
                name="bnWriteAccessGroupIDs"
                fluid
                multiple
                search
                selection
                options={bookingNoteAccessesOptions.map(opt => ({
                  ...opt,
                  text: t(opt.text, { ns: TRANSLATION_FILES.constants }),
                }))}
                onChange={this.handleInputChange}
                value={project.bnWriteAccessGroupIDs || []}
                style={{ marginBottom: '10px' }}
              />
              <Form.Select
                label={translateModels(t, 'bnDefaultPrivacy', 'project')}
                name="bnDefaultPrivacy"
                fluid
                onChange={this.handleInputChange}
                value={project.bnDefaultPrivacy}
                options={bookingNoteDefaultPrivacyOptions.map(opt => ({
                  ...opt,
                  text: t(opt.text, { ns: TRANSLATION_FILES.constants }),
                }))}
              />
              <Divider horizontal>{t('Pre-Sales Launch')}</Divider>
              {!canManagePreSalesLaunch(this.props.auth) &&
                <i style={{ color: 'grey', display: 'block', marginBottom: '5px' }}>{t('Only HQ can change these settings')}</i>
              }
              {['reserveDisabledRoleIDs', 'salesChartDisabledRoleIDs'].map(name => (
                <React.Fragment key={name}>
                  <Header
                    as="h5"
                    style={{ margin: '0 0 5px 0' }}
                  >
                    {translateModels(t, name, 'project')}
                    <i style={{ color: 'grey', marginLeft: '1em' }}>{t('Leave empty to allow all roles')}</i>
                  </Header>
                  <Dropdown
                    name={name}
                    fluid
                    multiple
                    disabled={!canManagePreSalesLaunch(this.props.auth)}
                    search
                    selection
                    options={preSalesLaunchRoleOptions.map(opt => ({
                      ...opt,
                      text: t(opt.text, { ns: TRANSLATION_FILES.constants }),
                    }))}
                    onChange={this.handleInputChange}
                    value={project[name] || []}
                    style={{ marginBottom: '10px' }}
                  />
                </React.Fragment>
              ))}
            </Grid.Column>
            <Grid.Column stretched={!this.isActiveTab('docx_templater_setting')} className={this.checkActiveTab('docx_templater_setting')}>
              <Divider horizontal>{t('Form Template')}</Divider>
              {project && project.id && (
                <DocxTemplaterForm
                  projectID={project.id}
                  project={project}
                  onSubmitBankerForm={this.handleBankerFormChange}
                />
              )}
              <Divider horizontal>{t('Merge-tag Dictionary')}</Divider>
              <MergeTagDictTabList />
              <Divider horizontal>{t('How-to Guide')}</Divider>
              <DocxTemplateGuides />
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('payment_setup')}>
              {this.hasAccess(true, true, true) &&
                <Divider horizontal>{t('Bank Accounts')}</Divider>
              }
              {this.hasAccess(true, true, false, true) &&
                <BankAccounts
                  data={project.projectBankAccount || []}
                  project={project}
                  loading={this.state.loading}
                  onDefaultAdd={(v, d) => {
                    this.handleAddBankAccount(v, d);
                  }}
                  onDefaultSave={(v, d) => {
                    this.handleSaveBankAccount(v, d);
                  }}
                />
              }
              {this.props.appConfig.data.settings && this.props.appConfig.data.settings.virtualAccountIsEnabled &&
                <Divider horizontal>{t('Virtual Account', { ns: TRANSLATION_FILES.constants })}</Divider>
              }
              {this.props.appConfig.data.settings && this.props.appConfig.data.settings.virtualAccountIsEnabled &&
                <p>
                  <Trans ns={TRANSLATION_FILES.screens}>
                    To configure Virtual Account for each units, visit this&nbsp;
                    <a style={{ color: '#0094B3' }} href={`/projects/${project.id}/units/edit/`}>page</a>
                  </Trans>
                  .
                </p>
              }
              <Divider horizontal>{t('Payment')}</Divider>
              <Form.Group grouped>
                <Form.Checkbox
                  label={translateModels(t, 'paymentFieldsRequired', 'project')}
                  name="paymentFieldsRequired"
                  checked={project.paymentFieldsRequired}
                  onChange={this.handleCheckBoxChange}
                />
              </Form.Group>
              <Form.Group grouped>
                <Form.Checkbox
                  label={
                    <label htmlFor="bookingFeeDeductiblePaymentPlan">
                      {translateModels(t, 'bookingFeeDeductiblePaymentPlan', 'project')} <i style={{ color: 'grey', marginLeft: '1em' }}>*{t('only applicable in Payment Plans')}</i>
                    </label>
                  }
                  name="bookingFeeDeductiblePaymentPlan"
                  checked={project.bookingFeeDeductiblePaymentPlan}
                  onChange={this.handleCheckBoxChange}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <AppForm.Input
                  label={translateModels(t, 'defaultBookingFeeAmount', 'project')}
                  name="defaultBookingFeeAmount"
                  value={project.defaultBookingFeeAmount}
                  onChange={this.handleInputChange}
                  ref={this.validation.defaultBookingFeeAmount}
                  type="number"
                  pattern="[0-9]*"
                />
              </Form.Group>
              <Form.Group grouped>
                <Form.Checkbox
                  label={
                    <label htmlFor="minBookingPaymentIsRequired">
                      {translateModels(t, 'minBookingPaymentIsRequired', 'project')} <i style={{ color: 'grey', marginLeft: '1em' }}>({t('Only for Reserved > Booked Status Change')})</i>
                    </label>
                  }
                  name="minBookingPaymentIsRequired"
                  checked={project.minBookingPaymentIsRequired}
                  onChange={this.handleCheckBoxChange}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <AppForm.Input
                  label={translateModels(t, 'minBookingPaymentAmount', 'project')}
                  name="minBookingPaymentAmount"
                  value={project.minBookingPaymentAmount}
                  onChange={this.handleInputChange}
                  ref={this.validation.minBookingPaymentAmount}
                  validation={project.minBookingPaymentIsRequired ? [required, {
                    validate: numericRange,
                    option: {
                      min: 0,
                      max: project.defaultBookingFeeAmount ? parseFloat(project.defaultBookingFeeAmount) : undefined,
                    },
                  }] : null}
                  type="number"
                  pattern="[0-9]*"
                  disabled={!project.minBookingPaymentIsRequired}
                />
              </Form.Group>
              <Header
                as="h5"
                style={{ margin: '0 0 5px 0' }}
              >
                {translateModels(t, 'paymentReceiptAccessGroupIDs', 'project')}
              </Header>
              <Dropdown
                name="paymentReceiptAccessGroupIDs"
                fluid
                multiple
                search
                selection
                options={paymentReceiptAccessesOptions.map(opt => ({
                  ...opt,
                  text: t(opt.text, { ns: TRANSLATION_FILES.constants }),
                }))}
                onChange={this.handleInputChange}
                value={project.paymentReceiptAccessGroupIDs || []}
                style={{ marginBottom: '10px' }}
              />
              <Divider horizontal>{t('Payment Method')}</Divider>
              <Form.Group grouped>
                <Form.Group className="form-label">
                  <Form.Field width={10}>
                    <Segment className="form-sof-segment" >
                      <Header as="h4">{t('Visibility settings')}</Header>
                      {
                        this.props.appConfig.data.settings && this.props.appConfig.data.settings.virtualAccountIsEnabled ? (
                          <Form.Group>
                            <Form.Field label={getConstantsLabel(t, PAYMENT_TYPES, 'virtual_account')} width={11} />
                            <Form.Field width={5}>
                              <Form.Checkbox
                                toggle
                                label={t('On', { ns: TRANSLATION_FILES.translation })}
                                name="virtual_account"
                                checked
                                disabled
                              />
                            </Form.Field>
                          </Form.Group>
                        ) : null
                      }
                      <Form.Group>
                        <Form.Field label={getConstantsLabel(t, PAYMENT_TYPES, 'bank_transfer')} width={11} />
                        <Form.Field width={5}>
                          <Form.Checkbox
                            toggle
                            label={t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(o => o === 'bank_transfer') ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                            name="bank_transfer"
                            checked={project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('bank_transfer')}
                            onChange={this.handlePaymentTypeChange}
                          />
                        </Form.Field>
                      </Form.Group>
                      <Form.Group>
                        <Form.Field label={getConstantsLabel(t, PAYMENT_TYPES, 'cheque')} width={11} />
                        <Form.Field width={5}>
                          <Form.Checkbox
                            toggle
                            label={t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(o => o === 'cheque') ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                            name="cheque"
                            checked={project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('cheque')}
                            onChange={this.handlePaymentTypeChange}
                          />
                        </Form.Field>
                      </Form.Group>
                      <Form.Group>
                        <Form.Field label={getConstantsLabel(t, PAYMENT_TYPES, 'cash')} width={11} />
                        <Form.Field width={5}>
                          <Form.Checkbox
                            toggle
                            label={t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(o => o === 'cash') ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                            name="cash"
                            checked={project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('cash')}
                            onChange={this.handlePaymentTypeChange}
                          />
                        </Form.Field>
                      </Form.Group>
                      <Form.Group>
                        <Form.Field label={getConstantsLabel(t, PAYMENT_TYPES, 'credit_card')} width={11} />
                        <Form.Field width={5}>
                          <Form.Checkbox
                            toggle
                            label={t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(o => o === 'credit_card') ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                            name="credit_card"
                            checked={project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('credit_card')}
                            onChange={this.handlePaymentTypeChange}
                          />
                        </Form.Field>
                      </Form.Group>
                      <Form.Group>
                        <Form.Field label={`${getConstantsLabel(t, PAYMENT_TYPES, 'online_payment')} (${t('Online Payment')})`} width={11} />
                        <Form.Field width={5}>
                          <Form.Checkbox
                            toggle
                            label={t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(o => o === 'online_payment') ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                            name="online_payment"
                            checked={project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('online_payment')}
                            onChange={this.handlePaymentTypeChange}
                          />
                        </Form.Field>
                      </Form.Group>
                      <Form.Group>
                        <Form.Field label={getConstantsLabel(t, PAYMENT_TYPES, 'others')} width={11} />
                        <Form.Field width={5}>
                          <Form.Checkbox
                            toggle
                            label={t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(o => o === 'others') ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                            name="others"
                            checked={project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('others')}
                            onChange={this.handlePaymentTypeChange}
                          />
                        </Form.Field>
                      </Form.Group>
                    </Segment>
                  </Form.Field>
                </Form.Group>
              </Form.Group>
              {(
                this.hasAccess(true, true, true) &&
                !this.props.appConfig.data.onlinePaymentEnabled
              ) &&
                <div>
                  <Divider horizontal>{t('MHub Pay Online')}</Divider>
                  <Form.Group grouped>
                    <Form.Checkbox
                      label={translateModels(t, 'onlinePaymentApproval', 'project')}
                      name="onlinePaymentApproval"
                      checked={project.onlinePaymentApproval}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Form.Group>
                  {
                    this.props.appConfig.data.paymsPaymentGateway === PAYMS_PAYMENT_GATEWAY_BILLPLZ ?
                      <div>
                        <Form.Group widths="equal">
                          <AppForm.Input
                            label={translateModels(t, 'newPaymsBillplzSercetKey', 'project')}
                            name="newPaymsBillplzSercetKey"
                            value={project.newPaymsBillplzSercetKey}
                            onChange={this.handleInputChange}
                            ref={this.validation.newPaymsBillplzSercetKey}
                          />
                          <AppForm.Input
                            label={translateModels(t, 'newPaymsBillplzSignatureKey', 'project')}
                            name="newPaymsBillplzSignatureKey"
                            value={project.newPaymsBillplzSignatureKey}
                            onChange={this.handleInputChange}
                            ref={this.validation.newPaymsBillplzSignatureKey}
                          />
                        </Form.Group>
                        <Form.Group widths="equal">
                          <AppForm.Input
                            label={translateModels(t, 'paymsBillplzCollectionID', 'project')}
                            name="paymsBillplzCollectionID"
                            value={project.paymsBillplzCollectionID}
                            onChange={this.handleInputChange}
                            ref={this.validation.paymsBillplzCollectionID}
                          />
                          <AppForm.Input
                            label={translateModels(t, 'paymsBillplzCollectionTitle', 'project')}
                            name="paymsBillplzCollectionTitle"
                            value={project.paymsBillplzCollectionTitle}
                            ref={this.validation.paymsBillplzCollectionTitle}
                            disabled
                          />
                        </Form.Group>
                      </div>
                    : ''
                  }
                  {
                    this.props.appConfig.data.paymsPaymentGateway === PAYMS_PAYMENT_GATEWAY_IPAY88 ?
                      <Form.Group widths="equal">
                        <AppForm.Input
                          label={translateModels(t, 'newPaymsIPay88MerchantCode', 'project')}
                          name="newPaymsIPay88MerchantCode"
                          value={project.newPaymsIPay88MerchantCode}
                          onChange={this.handleInputChange}
                          ref={this.validation.newPaymsIPay88MerchantCode}
                        />
                        <AppForm.Input
                          label={translateModels(t, 'newPaymsIPay88MerchantKey', 'project')}
                          name="newPaymsIPay88MerchantKey"
                          value={project.newPaymsIPay88MerchantKey}
                          onChange={this.handleInputChange}
                          ref={this.validation.newPaymsIPay88MerchantKey}
                        />
                      </Form.Group>
                    : ''
                  }
                </div>
              }
              <Divider horizontal>{t('Email notification (MHub Pay)')}</Divider>
              <Form.Field>
                <label htmlFor="manualSize">{t('New Payment Approval')}</label>
                <AppForm.Validate
                  ref={this.validation.newPaymentApprovalEmailNotifications}
                  onChange={(e, { value }) => this.handleAddEmail(e, value, 'newPaymentApprovalEmailNotifications')}
                >
                  <Dropdown
                    name="newPaymentApprovalEmailNotifications"
                    options={
                      project && project.newPaymentApprovalEmailNotifications ?
                        project.newPaymentApprovalEmailNotifications.map(eml => ({
                          text: eml,
                          value: eml,
                        })) :
                        []
                    }
                    placeholder={t('Add emails')}
                    noResultsMessage={t('Add emails')}
                    search
                    selection
                    fluid
                    multiple
                    allowAdditions
                    value={
                      project && project.newPaymentApprovalEmailNotifications ?
                        project.newPaymentApprovalEmailNotifications :
                        []
                    }
                  />
                </AppForm.Validate>
              </Form.Field>
              <Form.Field>
                <label htmlFor="manualSize">{t('New Payment Success')}</label>
                <AppForm.Validate
                  ref={this.validation.newPaymentSuccessEmailNotifications}
                  onChange={(e, { value }) => this.handleAddEmail(e, value, 'newPaymentSuccessEmailNotifications')}
                >
                  <Dropdown
                    name="newPaymentSuccessEmailNotifications"
                    options={
                      project && project.newPaymentSuccessEmailNotifications ?
                        project.newPaymentSuccessEmailNotifications.map(eml => ({
                          text: eml,
                          value: eml,
                        })) :
                        []
                    }
                    placeholder={t('Add emails')}
                    noResultsMessage={t('Add emails')}
                    search
                    selection
                    fluid
                    multiple
                    allowAdditions
                    value={
                      project && project.newPaymentSuccessEmailNotifications ?
                        project.newPaymentSuccessEmailNotifications :
                        []
                    }
                  />
                </AppForm.Validate>
              </Form.Field>
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('sales_chart_setup')}>
              <Grid style={{ height: '15%' }} verticalAlign="middle" textAlign="center">
                <Grid.Row>
                  <Grid.Column>
                    <Divider horizontal>{t('Storey Plan')}</Divider>
                    <Form.Group grouped>
                      <Form.Checkbox
                        toggle
                        label={t(project.salesChartEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                        name="salesChartEnabled"
                        checked={project.salesChartEnabled}
                        onChange={this.handleCheckBoxChange}
                      />
                    </Form.Group>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              {
                project.id && project.salesChartEnabled ? (
                  <Grid columns="equal">
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <Form.Select
                          label={t('Type')}
                          name="salesChartType"
                          fluid
                          onChange={this.handleInputChange}
                          value={project.salesChartType}
                          options={salesChartTypes}
                        />
                        <Form.Select
                          label={t('Template')}
                          name="salesChartTemplate"
                          fluid
                          onChange={this.handleInputChange}
                          value={project.salesChartTemplate}
                          options={salesChartTemplateTypes}
                        />
                        <Form.Select
                          disabled={!project.isLaunchMode}
                          label={translateModels(t, 'salesChartRefreshSeconds', 'project')}
                          name="salesChartRefreshSeconds"
                          fluid
                          onChange={this.handleInputChange}
                          value={project.salesChartRefreshSeconds}
                          options={this.salesChartRefreshTimes}
                        />
                        <Form.Field label={t('General Settings:')} />
                        <Form.Checkbox
                          label={t('Show price per size')}
                          name="salesChartSizePrice"
                          checked={project.salesChartSizePrice}
                          onChange={this.handleCheckBoxChange}
                        />
                        <Form.Field label={t('Agents/Staff Settings:')} />
                        <Form.Checkbox
                          label={t('Simple View Mode (Units are shown as Available/Unavailable)')}
                          name="salesChartSimpleMode"
                          checked={project.siteplanSettings &&
                            project.siteplanSettings.salesChartSimpleMode}
                          onChange={this.handleSiteplanSettingsChange}
                        />
                        <Form.Checkbox
                          label={t('Disable clicks on unavailable units (Storey plan)')}
                          name="salesChartDisableClickUnavailable"
                          disabled={project.siteplanSettings && !project.siteplanSettings.salesChartSimpleMode}
                          checked={project.siteplanSettings &&
                            project.siteplanSettings.salesChartDisableClickUnavailable}
                          onChange={this.handleSiteplanSettingsChange}
                          style={{ marginLeft: '20px' }}
                        />
                        <Form.Checkbox
                          label={t('Disable clicks on unavailable units (Unit list)')}
                          name="unitListDisableClickUnavailable"
                          disabled={project.siteplanSettings && !project.siteplanSettings.salesChartSimpleMode}
                          checked={project.siteplanSettings &&
                            project.siteplanSettings.unitListDisableClickUnavailable}
                          onChange={this.handleSiteplanSettingsChange}
                          style={{ marginLeft: '20px' }}
                        />
                        <Form.Checkbox
                          label={t('Hide unit price')}
                          name="salesChartHidePrice"
                          disabled={project.siteplanSettings && !project.siteplanSettings.salesChartSimpleMode}
                          checked={project.salesChartHidePrice}
                          onChange={this.handleCheckBoxChange}
                          style={{ marginLeft: '20px' }}
                        />
                        <Form.Checkbox
                          label={t('Hide unit size')}
                          name="salesChartHideSize"
                          disabled={project.siteplanSettings && !project.siteplanSettings.salesChartSimpleMode}
                          checked={project.salesChartHideSize}
                          onChange={this.handleCheckBoxChange}
                          style={{ marginLeft: '20px' }}
                        />
                        <Form.Checkbox
                          label={t('Show Delisted units as Unavailable')}
                          name="salesChartDelistedAsUnavailable"
                          disabled={project.siteplanSettings && !project.siteplanSettings.salesChartSimpleMode}
                          checked={project.siteplanSettings &&
                            project.siteplanSettings.salesChartDelistedAsUnavailable}
                          onChange={this.handleSiteplanSettingsChange}
                          style={{ marginLeft: '20px' }}
                        />
                        <Form.Field label={t('Public Settings:')} />
                        <Form.Checkbox
                          label={t('Hide price for public share')}
                          name="hidePublicPriceSalesChart"
                          disabled={!project.isPublic}
                          checked={project.hidePublicPriceSalesChart}
                          onChange={this.handleCheckBoxChange}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                ) : null
              }
              <Grid style={{ height: '15%' }} textAlign="center">
                <Grid.Row>
                  <Grid.Column>
                    <Divider horizontal>{t('Interactive Site Plan')}</Divider>
                    <Form.Group grouped>
                      <Form.Checkbox
                        toggle
                        label={t(project.siteplanAppEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                        name="siteplanAppEnabled"
                        checked={project.siteplanAppEnabled}
                        onChange={this.handleCheckBoxChange}
                      />
                    </Form.Group>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              {
                project.id && project.siteplanAppEnabled ? (
                  <Grid columns="equal">
                    <Grid.Row verticalAlign="middle">
                      <Grid.Column textAlign="left">
                        <b>{t('Siteplan')}</b>
                        <SortButton
                          loading={this.state.loading}
                          icon="download"
                          header={t('Units Tag')}
                          items={exportItems}
                        />
                      </Grid.Column>
                      <Grid.Column textAlign="right">
                        {
                          this.hasSiteplan() ? (
                            <Button
                              floated="right"
                              type="button"
                              onClick={this.handlePreviewSaleschart}
                              primary
                              content={t('Preview', { ns: TRANSLATION_FILES.translation })}
                              disabled={!oriProject.siteplanAppEnabled}
                            />
                          ) : (
                            <UploadModal
                              ref={(ref) => { this.uploadModal.siteplan = ref; }}
                              header="siteplan"
                              loading={this.state.loading}
                              onConfirm={(e, file) => {
                                this.uploadSiteplan(e, file);
                              }}
                              onClose={this.handleCheckBeforeClose}
                              content={opt => (
                                <UploadSiteplanForm
                                  ref={(ref) => { this.uploadForm.siteplan = ref; }}
                                  onSubmit={opt.onConfirm}
                                />
                                )}
                              disabled={!oriProject.siteplanAppEnabled}
                            />
                            )
                        }
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={16}>
                        {
                          this.hasSiteplan() ? (
                            <Segment.Group>
                              <Segment>
                                <Grid columns="equal" verticalAlign="middle" textAlign="left">
                                  <Grid.Column width={3}>
                                    <b>{t('SVG')}</b>
                                  </Grid.Column>
                                  <Grid.Column width={6}>
                                    <Label
                                      basic
                                      size="small"
                                      icon={this.hasSiteplan('svg') ? null : 'warning sign'}
                                      color={this.hasSiteplan('svg') ? 'green' : 'red'}
                                      content={t(this.hasSiteplan('svg') ? 'Uploaded' : 'Not uploaded')}
                                    />
                                  </Grid.Column>
                                  <Grid.Column textAlign="right">
                                    <UploadModal
                                      ref={(ref) => { this.uploadModal.svg = ref; }}
                                      header="svg"
                                      loading={this.state.loading}
                                      btnText={this.hasSiteplan('svg') ? t('Replace') : t('Upload', { ns: TRANSLATION_FILES.translation })}
                                      onConfirm={(e, file) => {
                                        this.replaceSiteplan(e, file, 'svg');
                                      }}
                                      onClose={() => this.handleCheckBeforeClose('svg')}
                                      content={opt => (
                                        <UploadSvgForm
                                          appConfig={this.props.appConfig}
                                          ref={(ref) => { this.uploadForm.svg = ref; }}
                                          onSubmit={opt.onConfirm}
                                          siteplan={project.siteplan}
                                        />
                                      )}
                                      disabled={!oriProject.siteplanAppEnabled}
                                    />
                                  </Grid.Column>
                                </Grid>
                              </Segment>
                              <Segment>
                                <Grid columns="equal" verticalAlign="middle" textAlign="left">
                                  <Grid.Column width={3}>
                                    <b>{t('Image')}</b>
                                  </Grid.Column>
                                  <Grid.Column width={6}>
                                    <Label
                                      basic
                                      size="small"
                                      icon={this.hasSiteplan('image') ? null : 'warning sign'}
                                      color={this.hasSiteplan('image') ? 'green' : 'red'}
                                      content={t(this.hasSiteplan('image') ? 'Uploaded' : 'Not uploaded')}
                                    />
                                  </Grid.Column>
                                  <Grid.Column textAlign="right">
                                    <UploadModal
                                      ref={(ref) => { this.uploadModal.image = ref; }}
                                      header="image"
                                      loading={this.state.loading}
                                      btnText={this.hasSiteplan('image') ? t('Replace') : t('Upload', { ns: TRANSLATION_FILES.translation })}
                                      onConfirm={(e, file) => {
                                        this.replaceSiteplan(e, file, 'image');
                                      }}
                                      onClose={() => this.handleCheckBeforeClose('image')}
                                      content={opt => (
                                        <UploadImageForm
                                          appConfig={this.props.appConfig}
                                          ref={(ref) => { this.uploadForm.image = ref; }}
                                          onSubmit={opt.onConfirm}
                                          siteplan={project.siteplan}
                                        />
                                      )}
                                      disabled={!oriProject.siteplanAppEnabled}
                                    />
                                  </Grid.Column>
                                </Grid>
                              </Segment>
                            </Segment.Group>
                          ) : (
                            <Message
                              info
                              header={`${t('Requirement')}:`}
                              list={[
                                t('SVG'),
                                t('JPEG'),
                                t('Both SVG and JPEG must has same resolution.'),
                              ]}
                            />
                            )
                        }
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <Form.Group widths={2}>
                          <Form.Group grouped>
                            <Form.Field label={t('Legends')} />
                            <Form.Group grouped>
                              <Form.Checkbox
                                label={t('Available', { ns: TRANSLATION_FILES.constants })}
                                name="hideAvailableLegend"
                                checked={project.siteplanSettings &&
                                  !project.siteplanSettings.hideAvailableLegend}
                                onChange={this.handleSiteplanSettingsChange}
                              />
                              <Form.Checkbox
                                label={t('Reserved', { ns: TRANSLATION_FILES.constants })}
                                name="hideReservedLegend"
                                checked={project.siteplanSettings &&
                                  !project.siteplanSettings.hideReservedLegend}
                                onChange={this.handleSiteplanSettingsChange}
                              />
                              <Form.Checkbox
                                label={t('Booked', { ns: TRANSLATION_FILES.constants })}
                                name="hideBookedLegend"
                                checked={project.siteplanSettings &&
                                  !project.siteplanSettings.hideBookedLegend}
                                onChange={this.handleSiteplanSettingsChange}
                              />
                              <Form.Checkbox
                                label={t('Sold', { ns: TRANSLATION_FILES.constants })}
                                name="hideSoldLegend"
                                checked={project.siteplanSettings &&
                                  !project.siteplanSettings.hideSoldLegend}
                                onChange={this.handleSiteplanSettingsChange}
                              />
                              <Form.Checkbox
                                label={t('Delist', { ns: TRANSLATION_FILES.constants })}
                                name="hideDelistLegend"
                                checked={project.siteplanSettings &&
                                  !project.siteplanSettings.hideDelistLegend}
                                onChange={this.handleSiteplanSettingsChange}
                              />
                            </Form.Group>
                          </Form.Group>
                          <Form.Group grouped>
                            <Form.Field label={t('General Settings:')} />
                            <Form.Checkbox
                              label={t('Hide unit layouts')}
                              name="hideLayouts"
                              checked={project.siteplanSettings &&
                                project.siteplanSettings.hideLayouts}
                              onChange={this.handleSiteplanSettingsChange}
                            />
                            <Form.Checkbox
                              label={t('Default filter Available')}
                              name="defaultFilter"
                              checked={project.siteplanSettings &&
                                project.siteplanSettings.defaultFilter}
                              onChange={this.handleSiteplanSettingsChange}
                            />
                            {
                              project && project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ? (
                                <Form.Checkbox
                                  label={t('Hide towers and levels')}
                                  name="hideTowersAndLevels"
                                  checked={project.siteplanSettings &&
                                    project.siteplanSettings.hideTowersAndLevels}
                                  onChange={this.handleSiteplanSettingsChange}
                                />
                              ) : null
                            }
                            <Form.Field label={t('Agents/Staff Settings:')} />
                            <Form.Checkbox
                              label={t('Simple View Mode (Units are shown as Available/Unavailable)')}
                              name="siteplanSimpleMode"
                              checked={project.siteplanSettings &&
                                project.siteplanSettings.siteplanSimpleMode}
                              onChange={this.handleSiteplanSettingsChange}
                            />
                            <Form.Checkbox
                              label={t('Show Delisted units as Unavailable')}
                              name="siteplanDelistedAsUnavailable"
                              disabled={project.siteplanSettings && !project.siteplanSettings.siteplanSimpleMode}
                              checked={project.siteplanSettings &&
                                project.siteplanSettings.siteplanDelistedAsUnavailable}
                              onChange={this.handleSiteplanSettingsChange}
                              style={{ marginLeft: '20px' }}
                            />
                            <Form.Field label={t('Public Settings:')} />
                            <Form.Checkbox
                              label={t('Hide price for public share')}
                              name="hidePublicPriceSiteplan"
                              disabled={!project.isPublic}
                              checked={project.hidePublicPriceSiteplan}
                              onChange={this.handleCheckBoxChange}
                            />
                            <Form.Select
                              label={t('Overlay mode')}
                              name="overlayMode"
                              fluid
                              onChange={this.handleSiteplanSettingsChange}
                              value={project.siteplanSettings &&
                                project.siteplanSettings.overlayMode ?
                                project.siteplanSettings.overlayMode : 'text'}
                              options={this.overlayModes.map(om => ({
                                ...om,
                                text: t(om.text, { ns: TRANSLATION_FILES.constants }),
                              }))}
                            />
                          </Form.Group>
                        </Form.Group>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                ) : null
              }
            </Grid.Column>
            {(this.hasUpdateAccess() && this.hasAccess(true, true, false)) ?
              <Grid.Column stretched className={this.checkActiveTab('marketplace')}>
                <Grid.Row>
                  <Grid.Column>
                    <Form.Field
                      label={
                        <div>
                          <Header
                            as="h3"
                            style={{ marginBottom: '5px' }}
                          >
                            {t('Launch your unsold projects to MHub agents to help you sell faster')}
                          </Header>
                          <Label
                            style={{
                              background: 'transparent',
                              padding: 0,
                              fontSize: '1rem',
                            }}
                          >
                            {t('For successful booking transaction, these info are required')}:
                          </Label>
                        </div>
                      }
                      style={{ marginBottom: '2rem' }}
                    />
                    <List bulleted>
                      <List.Item style={{ marginBottom: '2rem' }}>
                        <Header
                          as="h5"
                          style={{ marginBottom: '5px' }}
                        >
                          {t('Documents').toUpperCase()}
                        </Header>
                        <Label
                          style={{
                            background: 'transparent',
                            padding: 0,
                            fontSize: '1rem',
                          }}
                        >
                          {t('E-sales kit or PDF Brochure which can be uploaded at')} &nbsp;
                          <Button
                            as={Link}
                            className="flash-button"
                            to={`/projects/${this.state.project.id}/documents/`}
                            style={{
                              opacity: 1,
                            }}
                          >
                            {t('Documents')}
                          </Button>
                        </Label>
                      </List.Item>
                      <List.Item style={{ marginBottom: '2rem' }}>
                        <Header
                          as="h5"
                          style={{ marginBottom: '5px' }}
                        >
                          {t('Bank Account Info').toUpperCase()}
                        </Header>
                        <Label
                          style={{
                            background: 'transparent',
                            padding: 0,
                            fontSize: '1rem',
                          }}
                        >
                          {t('Your account info for agents to bank-in booking fee deposit at')} &nbsp;
                          <Button
                            className="flash-button"
                            onClick={e => this.handleNavigatePayment(e, 'payment_setup')}
                          >
                            {t('Payment Setup')}
                          </Button>
                        </Label>
                      </List.Item>
                      <List.Item style={{ marginBottom: '2rem' }}>
                        <Header
                          as="h5"
                          style={{ marginBottom: '5px' }}
                        >
                          {t('Booking Fee Deposit').toUpperCase()}
                        </Header>
                        <Label
                          style={{
                            background: 'transparent',
                            padding: 0,
                            fontSize: '1rem',
                          }}
                        >
                          {t('The amount you require to secure a unit at')} &nbsp;
                          <Button
                            className="flash-button"
                            onClick={e => this.handleNavigatePayment(e, 'payment_setup')}
                          >
                            {t('Payment Setup')}
                          </Button>
                        </Label>
                      </List.Item>
                      <List.Item style={{ marginBottom: '2rem' }}>
                        <AppForm.Input
                          label={translateModels(t, 'commission', 'project').toUpperCase()}
                          name="commission"
                          placeholder={t('e.g 1% or RM5000 - RM50,000')}
                          value={project.commission}
                          onChange={this.handleInputChange}
                        />
                      </List.Item>
                      <List.Item style={{ marginBottom: '2rem' }}>
                        <AppForm.Input
                          label={`${translateModels(t, 'commissionDescription', 'project').toUpperCase()} (${t('Optional')})`}
                          name="commissionDescription"
                          placeholder={t('e.g First 50% paid upon SPA signed. The other 50% to be paid out after first loan disbursement')}
                          value={project.commissionDescription}
                          onChange={this.handleInputChange}
                        />
                      </List.Item>
                    </List>
                    <Form.Group widths="equal">
                      <Segment style={{ marginRight: '1.5em' }}>
                        <Form.Group inline style={{ margin: 0 }}>
                          <Form.Group grouped style={{ paddingRight: '1.5em', margin: 0 }}>
                            <Form.Field label={t('Launch to Marketplace')} />
                          </Form.Group>
                          <Form.Group style={{ margin: 0 }}>
                            <Form.Group grouped style={{ paddingLeft: '1.5em' }}>
                              <Form.Checkbox
                                toggle
                                label={t(`${project.marketplaceIsPublish ? 'Publish' : 'Unpublish'}${project.marketplaceIsPublish === oriProject.marketplaceIsPublish ? 'ed' : ''}`)}
                                name="marketplaceIsPublish"
                                checked={project.marketplaceIsPublish}
                                onChange={!project.marketplaceIsPublish && (!project.projectBankAccount || project.defaultBookingFeeAmount <= 0 || !project.documents || !project.commission) ? this.handleFlashMPCriteriaMsg : this.handleCheckBoxChange}
                              />
                            </Form.Group>
                          </Form.Group>
                        </Form.Group>
                        <Form.Field>
                          <Label
                            style={{
                              background: 'transparent',
                              padding: 0,
                              fontSize: '1rem',
                            }}
                          >
                            {t('I Agree to the')} &nbsp;
                            <Button onClick={this.showTnC} style={{ opacity: 1 }} className="flash-button">
                              {t('Terms and Conditions')}
                            </Button>
                            <MarketplaceTncModal
                              open={this.state.openTncModal}
                              header={t('Terms and Conditions')}
                              onClose={this.handleOnClose}
                            />
                          </Label>
                        </Form.Field>
                      </Segment>
                      {
                        this.buyerMarketplaceHasAccess() ?
                          <Segment style={{ marginTop: '0' }}>
                            <Form.Group inline style={{ margin: 0 }}>
                              <Form.Group grouped style={{ paddingRight: '1.5em', margin: 0 }}>
                                <Form.Field label={t('Launch to Showroom for Buyers')} />
                              </Form.Group>
                              <Form.Group style={{ margin: 0 }}>
                                <Form.Group grouped style={{ paddingLeft: '1.5em' }}>
                                  <Form.Checkbox
                                    toggle
                                    label={t(`${project.marketplaceBuyerIsPublish ? 'Publish' : 'Unpublish'}${project.marketplaceBuyerIsPublish === oriProject.marketplaceBuyerIsPublish ? 'ed' : ''}`)}
                                    name="marketplaceBuyerIsPublish"
                                    checked={project.marketplaceBuyerIsPublish}
                                    onChange={!project.marketplaceBuyerIsPublish && (!project.projectBankAccount || project.defaultBookingFeeAmount <= 0 || !project.documents) ? this.handleFlashMPCriteriaMsg : this.handleCheckBoxChange}
                                  />
                                </Form.Group>
                              </Form.Group>
                            </Form.Group>
                            <Form.Field>
                              <Label
                                style={{
                                  background: 'transparent',
                                  padding: 0,
                                  fontSize: '1rem',
                                }}
                              >
                                {t('I Agree to the')} &nbsp;
                                <Button onClick={this.showTnC} style={{ opacity: 1 }} className="flash-button">
                                  {t('Terms and Conditions')}
                                </Button>
                                <MarketplaceTncModal
                                  open={this.state.openTncModal}
                                  header={t('Terms and Conditions')}
                                  onClose={this.handleOnClose}
                                />
                              </Label>
                            </Form.Field>
                            <Form.Group widths="equal" style={{ margin: 0, marginTop: '1em' }}>
                              <Form.Group inline style={{ paddingRight: '1.5em', margin: 0 }}>
                                <Form.Field label={t('Restrict buyer’s access to project')} style={{ paddingRight: '0.5em' }} />
                                <Popup
                                  className="srb"
                                  content={t('If this toggle is enabled, this project will be invisible inside of SRB unless if access is granted to a customer inside of MHub Lead')}
                                  on="click"
                                  wide
                                  positionFixed
                                  style={{ background: '#596975' }}
                                  position="bottom right"
                                  trigger={<Button
                                    icon="info circle"
                                    size="large"
                                    style={{ padding: '0 .2em 0 0', background: 'none' }}
                                  />}
                                  pinned
                                  inverted
                                  onOpen={(e) => {
                                    e.preventDefault();
                                  }}
                                  onClose={(e) => {
                                    e.preventDefault();
                                  }}
                                />
                              </Form.Group>
                              <Form.Group style={{ margin: 0 }}>
                                <Form.Group grouped style={{ paddingLeft: '1.5em' }}>
                                  <Form.Checkbox
                                    toggle
                                    label={t(project.isProjectBAC ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                    name="isProjectBAC"
                                    checked={project.isProjectBAC}
                                    onChange={this.handleCheckBoxChange}
                                  />
                                </Form.Group>
                              </Form.Group>
                            </Form.Group>
                          </Segment> : null
                      }
                    </Form.Group>
                    {isVietnamCompany && this.buyerMarketplaceHasAccess() && (
                      <Form.Field>
                        <AppForm.Input
                          label={t('SRB sales chart expiry (minutes)')}
                          name="srbStoreyPlanExpiryMinutes"
                          type="number"
                          min={1}
                          max={30}
                          step={1}
                          required={!!this.props.auth.isHeadquarters}
                          disabled={!this.props.auth.isHeadquarters}
                          value={project.srbStoreyPlanExpiryMinutes}
                          onChange={this.handleInputChange}
                          ref={this.validation.srbStoreyPlanExpiryMinutes}
                          validation={this.props.auth.isHeadquarters ? [validateSRBExpiry] : []}
                          message={t('Enter a whole number from 1 to 30 minutes.')}
                        />
                        <i>{t('Each opened sales chart session expires after this duration. Reloading does not extend it. Only HQ can edit.')}</i>
                      </Form.Field>
                    )}
                    {
                      this.buyerMarketplaceHasAccess() ?
                        <Divider horizontal>{t('Booking Form & E-Signing').toUpperCase()}</Divider> : null
                    }
                    {
                      this.buyerMarketplaceHasAccess() ?
                        <Form.Group widths="equal">
                          <Form.Group widths="equal" style={{ paddingRight: '1.5em' }}>
                            <Form.Field style={{ paddingTop: '.65em' }} label={translateModels(t, 'mpAllowESignFormAtReserve', 'project')} />
                            <Form.Group>
                              <Popup
                                className="srb"
                                content={t('If this setting is enabled, buyers will have access to the project\'s booking form(s) and e-signing despite being in the Reserved/ Pending status')}
                                on="click"
                                wide
                                positionFixed
                                style={{ background: '#596975' }}
                                position="bottom right"
                                trigger={<Button
                                  icon="question circle outline"
                                  size="large"
                                  style={{ padding: '0 .2em 0 .3em', background: 'none' }}
                                />}

                                pinned
                                inverted
                                onOpen={(e) => {
                                  e.preventDefault();
                                }}
                                onClose={(e) => {
                                  e.preventDefault();
                                }}
                              />
                              <Form.Group grouped style={{ paddingLeft: '.5em' }}>
                                <Form.Checkbox
                                  toggle
                                  label={t(project.mpAllowESignFormAtReserve ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="mpAllowESignFormAtReserve"
                                  checked={project.mpAllowESignFormAtReserve}
                                  onChange={this.handleCheckBoxChange}
                                />
                              </Form.Group>
                            </Form.Group>
                          </Form.Group>
                        </Form.Group> : null
                    }
                    <Divider horizontal>{t('Event Timer').toUpperCase()}</Divider>
                    <Form.Group widths="equal">
                      <Form.Field>
                        <Label
                          style={{
                            background: 'transparent',
                            padding: 0,
                          }}
                        >Event date</Label>
                        <Form.Input
                          fluid
                          placeholder={t('Select date and time')}
                          value={
                            eventTime ?
                            eventTime.format(inputDateFormat)
                            : ''
                          }
                          onFocus={() => this.handleOnVisible(true)}
                          style={{ marginTop: '1rem' }}
                          icon={
                            project.mpBuyerEventLaunchAt ?
                              <Icon
                                color="red"
                                link
                                name="x"
                                onClick={this.resetEventTimer}
                                title="Clear"
                              />
                              : 'calendar'
                           }
                        />
                        <DateTimePicker
                          minDate={moment()}
                          onChange={(value, visible) => this.handleDateTimeInputChange(value, visible)}
                          value={
                            project.mpBuyerEventLaunchAt && moment(project.mpBuyerEventLaunchAt).isAfter(moment()) ?
                              moment(project.mpBuyerEventLaunchAt).toDate() : moment().toDate()
                          }
                          visible={isVisible}
                          useBrowserTimezone={isVietnamCompany}
                        />
                      </Form.Field>
                      <Form.Field>
                        <Label
                          style={{
                            background: 'transparent',
                            padding: 0,
                          }}
                        >{t('Countdown timer')}</Label>
                        <Segment className="segment1">
                          <p>{t('Time remaining to Event')}</p>
                          {
                            project.mpBuyerEventLaunchAt ? (
                              <div className="countDownBox" style={{ display: 'inline-block', fontSize: '1.5rem' }}>
                                {/* No onFinished: the preview countdown running out must not clear
                                    the stored event date — expired dates stay meaningful (CPI-1204) */}
                                <Countdown
                                  targetDate={moment(project.mpBuyerEventLaunchAt).toDate()}
                                  timeSeparator={' : '}
                                  format={this.getCountdownFormat(project.mpBuyerEventLaunchAt)}
                                  showUnit
                                  leadingZero
                                />
                                <Button
                                  content={t('Cancel timer')}
                                  inverted
                                  color="red"
                                  type="button"
                                  style={{ marginTop: '1.5rem' }}
                                  onClick={this.resetEventTimer}
                                />
                              </div>
                            ) : (
                              <h4 style={{ display: 'inline-block', fontSize: '1.5rem' }}>
                                {t('{{count}} days', { count: '0' })} : {t('{{count}} hours', { count: '0' })} : {t('{{count}} minutes', { count: '0' })} : {t('{{count}} seconds', { count: '0' })}
                              </h4>
                            )
                          }
                        </Segment>
                      </Form.Field>
                    </Form.Group>
                  </Grid.Column>
                </Grid.Row>
              </Grid.Column>
              : ''
            }
            {this.hasUpdateAccess() ?
              <Grid.Column stretched className={this.checkActiveTab('booking_fields')}>
                <CustomField
                  data={project.projectBookingCustomFields || []}
                  onChangeData={this.handleOnChangeCustomFieldData}
                  type="booking"
                />
              </Grid.Column>
              : ''
            }
            {this.hasUpdateAccess() ?
              <Grid.Column stretched className={this.checkActiveTab('tier_pricing')}>
                <ProjectPricingTier
                  data={project.projectPricings || []}
                  onDelete={this.handlePricingTierDelete}
                  onChangeData={this.handlePricingTierChange}
                  onSaveData={this.handlePricingSave}
                  onDefaultInputChange={this.handleInputChange}
                  defaultBumiProjectPricingID={project.defaultBumiProjectPricingID}
                  defaultProjectPricingID={project.defaultProjectPricingID}
                />
                <Segment basic>
                  <Button
                    fluid
                    primary
                    onClick={this.handleImportPricingClick}
                  >
                    Bulk Import Discount From Excel
                  </Button>
                </Segment>
              </Grid.Column>
              : ''
            }
            <Grid.Column stretched className={this.checkActiveTab('access')}>
              {this.hasAccess(true, true, false) &&
                <div>
                  <Divider horizontal>{t('Nett Selling Price')}</Divider>
                  <Form.Group widths="equal">
                    <Form.Checkbox
                      label={t('Business Unit Leaders')}
                      name="accessBULNettSellingPrice"
                      checked={project.accessBULNettSellingPrice}
                      onChange={this.handleCheckBoxChange}
                    />
                    <Form.Checkbox
                      label={t('Staff & Agent')}
                      name="accessStaffNettSellingPrice"
                      checked={project.accessStaffNettSellingPrice}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Form.Group>
                </div>
              }
            </Grid.Column>
            {
              this.hasUpdateAccess() ?
                <Grid.Column stretched className={this.checkActiveTab('letter_settings')}>
                  <Divider horizontal>
                    {translateModels(t, 'loanReminderLetter', 'project')}
                  </Divider>
                  <Form.Select
                    label={translateModels(t, 'printLoanReminderType', 'project')}
                    name="printLoanReminderType"
                    fluid
                    onChange={this.handleInputChange}
                    value={project.printLoanReminderType}
                    options={printLoanReminderTypes}
                  />
                  <TextFieldMarkdownPreview
                    data={project.loanReminderLetter || ''}
                    name="loanReminderLetter"
                    labelName={translateModels(t, 'loanReminderLetter', 'project')}
                    onDefaultInputChange={this.handleInputChange}
                  />
                  <Divider horizontal>
                    {translateModels(t, 'spaReminderLetter', 'project')}
                  </Divider>
                  <Form.Select
                    label={translateModels(t, 'printSPAType', 'project')}
                    name="printSPAType"
                    fluid
                    onChange={this.handleInputChange}
                    value={project.printSPAType}
                    options={printSPAReminderTypes}
                  />
                  <TextFieldMarkdownPreview
                    data={project.spaReminderLetter || ''}
                    name="spaReminderLetter"
                    labelName={translateModels(t, 'spaReminderLetter', 'project')}
                    onDefaultInputChange={this.handleInputChange}
                  />
                  <Divider horizontal>
                    {translateModels(t, 'terminationLetter', 'project')}
                  </Divider>
                  <Form.Select
                    label={translateModels(t, 'printTerminationType', 'project')}
                    name="printTerminationType"
                    fluid
                    onChange={this.handleInputChange}
                    value={project.printTerminationType}
                    options={printTerminationTypes}
                  />
                  <TextFieldMarkdownPreview
                    data={project.terminationLetter || ''}
                    name="terminationLetter"
                    labelName={translateModels(t, 'terminationLetter', 'project')}
                    onDefaultInputChange={this.handleInputChange}
                  />
                </Grid.Column>
                : ''
            }
            <Grid.Column stretched className={this.checkActiveTab('currency_settings')}>
              <Currencies
                allowSwitchingDefault
                companyDefaultCurrency={this.getCompanyDefaultCurrency()}
                currenciesProvided={this.getCompanyCurrencyOptions()}
                data={project.projectCurrency || []}
                loading={this.state.loading}
                onDefaultAdd={(v, d) => {
                  this.handleAddCurrency(v, d);
                }}
                onDefaultDelete={(e, d) => {
                  this.handleDeleteCurrency(e, d);
                }}
                onDefaultMakeDefault={(e, d) => {
                  this.handleMakeDefaultCurrency(e, d);
                }}
                onDefaultSave={(v, d) => {
                  this.handleSaveCurrency(v, d);
                }}
              />
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('options')}>
              <SpecificationTable
                type="projectOptions"
                editable
                isEditing
                hideButton
                notFoundNode={<p>{t('No API options')}.</p>}
                headerNode={t('API Options')}
                data={project.options}
                onChange={this.handleOptionChange}
                loading={this.state.loading}
              />
              <SpecificationTable
                type="projectMappings"
                editable
                isEditing
                hideButton
                notFoundNode={<p>{t('No Project Mapped yet')}.</p>}
                headerNode={t('Project Mapping')}
                data={project.mappings}
                onChange={this.handleMappingChange}
                loading={this.state.loading}
              />
            </Grid.Column>
            {
              this.hasUpdateAccess() ?
                <Grid.Column stretched className={this.checkActiveTab('reservation_token_settings')}>
                  <Grid>
                    <Grid.Column>
                      <Divider horizontal>{t('Reservation Token Settings')}</Divider>
                      <AppForm.Input
                        label={t('Price')}
                        name="priceMinor"
                        type="number"
                        min="1"
                        step="1"
                        value={projectReservationTokenSetting.priceMinor}
                        validation={[required, {
                          validate: numericRange,
                          option: { min: 1 },
                        }]}
                        ref={this.rtValidation.rtPriceMinor}
                        onChange={this.handleReservationTokenSettingChange}
                      />
                      <AppForm.Input
                        label={t('Validity Duration (Days)')}
                        name="validityDurationDays"
                        type="number"
                        min="1"
                        step="1"
                        value={projectReservationTokenSetting.validityDurationDays}
                        validation={[required, {
                          validate: numericRange,
                          option: { min: 1 },
                        }]}
                        ref={this.rtValidation.rtValidityDurationDays}
                        onChange={this.handleReservationTokenSettingChange}
                      />
                      <AppForm.Input
                        label={t('Limit Per Opportunity')}
                        name="limitPerOpportunity"
                        type="number"
                        min="1"
                        step="1"
                        value={projectReservationTokenSetting.limitPerOpportunity}
                        validation={[required, {
                          validate: numericRange,
                          option: { min: 1 },
                        }]}
                        ref={this.rtValidation.rtLimitPerOpportunity}
                        onChange={this.handleReservationTokenSettingChange}
                      />
                      <Form.Select
                        label={t('Currency')}
                        name="currencyCode"
                        fluid
                        options={[
                          { key: 'MYR', text: 'MYR', value: 'MYR' },
                          { key: 'IDR', text: 'IDR', value: 'IDR' },
                          { key: 'VND', text: 'VND', value: 'VND' },
                        ]}
                        value={projectReservationTokenSetting.currencyCode}
                        onChange={this.handleReservationTokenSettingChange}
                      />
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
                : null
            }
          </Grid.Row>
        </Grid>
        <Grid>
          <Grid.Row>
            <Grid.Column stretched>
              <UnpublishProjectModal
                open={this.state.openModal}
                onConfirm={this.handleSubmit}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}

export default withTranslation(
  [...namespaces, TRANSLATION_FILES.models.project, TRANSLATION_FILES.models.booking],
  { withRef: true },
)(
  withRouter(connect(
  ProjectForm.mapStateToProps, null, null, { withRef: true },
)(ProjectForm), { withRef: true }));



// WEBPACK FOOTER //
// ./src/containers/Projects/Form.jsx